import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import MainCards from "../../components/common/mainCards";
import bannerImgLogo from "../../assets/images/bannerImgLogo.svg";
import medalStar from "../../assets/images/medal-star.svg";
import trendUp from "../../assets/images/trendUp.svg";
import RE_Logo from "../../assets/images/RE_Logo.svg";
import note from "../../assets/images/note.png";
import clipboardTick from "../../assets/images/clipboardTick.svg";
import infoCircle from "../../assets/images/infoCircle.svg";
import clipboardClose from "../../assets/images/clipboard-close.svg";
import AddIcon from "../../assets/images/AddIcon.svg";
import userProfileStar from "../../assets/images/user-profile-star.svg";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import {
  Checkbox,
  FormControlLabel,
  ListItemButton,
  Card,
  Box,
  Typography,
  List,
  ListItem,
  Avatar,
  Button,
  Tooltip,
} from "@mui/material";
import TabCards from "../../components/tabCards";
import celebration from "../../assets/images/celebration2.svg";
import SpacesModal from "../adminModals/spacesModal";
import LeadershipCornerModal from "../adminModals/leadershipCornerMdl";
import HolidayModal from "../adminModals/holidaysModal";
import InternalJobPosting from "../adminModals/internalJobPosting";
import RESocial from "../adminModals/reSocialModal";
import IRefer from "../adminModals/iReferModal";
import OpenRoad from "../adminModals/openRoadModal";
import SocialMission from "../adminModals/socialMissionModal";
import dashboardService from "../../services/DashboardServices";
import {
  NewJoiner,
  Holiday,
  Spaces,
  LearningDevelopmentFormDataState,
  LeadershipCornerState,
  Wallpaper,
  BirthdayWorkAnniversaries,
  JobPosting,
  PerformanceManagementList,
  LeadershipCornerListData,
  RESocialList,
  openRoadState,
  openRoadListData,
  UserWishesState,
  FormattedUserWishesEvent,
  RewardsRecognitionDataData,
  OurMotorCycle,
  NPI,
  SocialMissionListData,
  SocialMissionState,
  UseFullLinks,
  EmployeeIReferralList,
  EmployeeIReferListData,
  EventsListData,
  EventsUpdateData,
  SearchResultItem,
  REImagingDataList,
  REImagingUpdateData,
} from "../../types/dashboard/index";
import BannerImageModal from "../adminModals/bannerImageModal";
import LearningDevelopmentModal from "../adminModals/learningDevelopmentModal";
import WallpaperModal from "../adminModals/wallpaperModal";
import EventsModal from "../adminModals/eventsModal";
import PerformanceManagement from "../adminModals/performanceManagement";
import UseFullLinksModals from "../adminModals/usefullLinksModal";
import AllTheHelpYouNeedModal from "../adminModals/REImagine/allTheHelpModalRE";
import IdeaCapturingModal from "../adminModals/REImagine/IdeaCaptureREModal";
import EditIcon from "../../assets/images/editIcon.svg";
import DeleteIcon from "../../assets/images/deleteIcon.svg";
import { showToast } from "../../components/common/toastNotification";
import RewardsAndRecognitionModal from "../adminModals/rewardsAndRecognitionModal";
import DeleteModal from "../../components/common/DeleteModal";
import {
  formatDate,
  getDateRangeFilter,
} from "../../helper/getDateRangeFilter";
import MediaCardSection from "../../components/common/mediaCards/mediaCardSection";
import BannerSlider from "../../components/bannerSlider";
import { getSocialIcon } from "../../helper/reSocialIconList";
import OurMotorcycle from "../adminModals/ourMotorcyclesModal";
import VideoModal from "../../components/common/VideoModal";
import NPIModal from "../adminModals/NPIModal";
import { useAppSelector, useAppDispatch } from "../../globalState/hooks";
import DashboardSearchModal from "../adminModals/dashboardSeachModal";
import { setDashboardSearchKey } from "../../globalState/actions/dashboard/dashboardAction";
import AwardAccepted from "../successPopUp/awardAccepted";
import CustomTooltip from "../../components/common/customTooltip";
import { AccessRoleMasterModule } from "../../components/accessRoleMaster";
import ReImagineAccessModal from "../successPopUp/reImagineAcceptedPopUp";
import { LoginRootState } from "../../types/login";
import RewardAcceptanceForm from "../successPopUp/rewardAcceptanceForm";
import SendWishesHeader from "../../components/R&R/sendWishesR&R";

const Dashboard: React.FC = () => {
  const dispatch = useAppDispatch();
  const userDetails = useAppSelector(
    (state: LoginRootState) => state.authReducer.loginDetials
  );
  const financialYear = useAppSelector(
    (state) =>
      state.dashboardReducer?.financialYear || { startDate: "", endDate: "" }
  );
  const hasCXOAccess = userDetails.isCXO;
  const hasIsSPOCAccess = userDetails.isSPOC;
  const hasBannerAccess = AccessRoleMasterModule("Banner");
  const hasSpacesAccess = AccessRoleMasterModule("Spaces");
  const hasLeadershipCornerAccess = AccessRoleMasterModule("Leadership Corner");
  const hasHolidaysAccess = AccessRoleMasterModule("Holidays");
  const hasRewardsRecognitionAccess = AccessRoleMasterModule(
    "Rewards and Recognition"
  );
  const hasREImagineAccess = AccessRoleMasterModule("REImagine");
  const hasLearningDevelopmentAccess = AccessRoleMasterModule(
    "Learning & Development"
  );
  const hasInternalJobPostingAccess = AccessRoleMasterModule(
    "Internal Job Posting"
  );
  const hasEmployeeReferralProgramAccess = AccessRoleMasterModule(
    "iRefer - Employee Referral Program"
  );
  const hasOpenRoadAccess = AccessRoleMasterModule("Open Road (DEI)");
  const hasOurSocialMissionAccess =
    AccessRoleMasterModule("Our Social Mission");
  const hasPerformanceManagementAccess = AccessRoleMasterModule(
    "Performance Management"
  );
  // const hasNewJoinerAccess = AccessRoleMasterModule("New Joiner");
  const hasNPIAccess = AccessRoleMasterModule("NPI");
  const hasUsefulLinksAccess = AccessRoleMasterModule("Useful Links");
  const hasWallpapersAccess = AccessRoleMasterModule("Wallpapers");
  const hasEventsAccess = AccessRoleMasterModule("Events");
  const hasRESocialAccess = AccessRoleMasterModule("RE Social");
  const hasMotorcyclesAccess = AccessRoleMasterModule("Motorcycles");

  const navigate = useNavigate();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<
    | Holiday
    | Spaces
    | LearningDevelopmentFormDataState
    | Wallpaper
    | LeadershipCornerState
    | JobPosting
    | OurMotorCycle
    | NPI
    | UseFullLinks
    | null
  >(null);
  const [deleteType, setDeleteType] = useState<
    | "holiday"
    | "space"
    | "learningDevelopment"
    | "wallpaper"
    | "LeadershipCorner"
    | "internalJobPosting"
    | "performanceManagement"
    | "OpenRoad"
    | "motorcycleData"
    | "NPI"
    | "socialMission"
    | "events"
    | "UseFullLinks"
    | "iReferral"
    | null
  >(null);
  const customOrder = [
    "LinkedIn",
    "TV",
    "Instagram",
    "YouTube",
    "Twitter",
    "Google+",
  ];
  const [isLoading, setIsLoading] = useState(false);
  const [bannerImageList, setBannerImageList] = useState([]);
  const [newJoiners, setNewJoiners] = useState<NewJoiner[]>([]);
  const [selectedFilter, setSelectedFilter] = useState("Last 7 days");
  const [selectAllNewJoinersChecked, setSelectAllNewJoinersChecked] =
    useState(false);
  const [selectedLeadershipCornerFilter, setSelectedLeadershipCornerFilter] =
    useState("All");

  const [internalJobOpen, setInternalJobOpen] = useState(false);
  const [jobUpdateData, setJobUpdateData] = useState<JobPosting>(
    {} as JobPosting
  );
  const [spaces, setSpaces] = useState<Spaces[]>([]);
  const [spaceMdl, setSpaceMdl] = useState(false);
  const [reSocialOpen, setReSocialOpen] = useState(false);
  const [iReferOpen, setIReferOpen] = useState(false);
  const [openRoadOpen, setOpenRoadOpen] = useState(false);
  const [socialMissionOpen, setSocialMissionOpen] = useState(false);
  const [holidays, setHolidays] = useState<Holiday[]>([]);
  const [leadershipCornerMdl, setLeadershipCornerMdl] = useState(false);
  const [holidayMdl, setHolidayMdl] = useState(false);
  const [isREImagineModalOpen, setIsREImagineModalOpen] = useState(false);
  const [rewardAndRecognitionModalOpen, setRewardAndRecognitionModalOpen] =
    useState(false);
  const [learningDevelopmentMdl, setLearningDevelopmentMdl] = useState(false);
  const [bannerImageMdl, setBannerImageMdl] = useState(false);
  const [isYesterdayChecked, setIsYesterdayChecked] = useState(false);
  const [isWallpaperModalOpen, setIsWallpaperModalOpen] = useState(false);
  const [isVideoVaultModalOpen, setIsVideoVaultModalOpen] = useState(false);
  const [isBirthdayLoader, setIsBirthdayLoader] = useState(false);
  const [isNewJoinerLoader, setIsNewJoinerLoader] = useState(false);
  const [isOurMotorcycleOpen, setIsOurMotorcycleOpen] = useState(false);
  const [isPerformanceModalOpen, setIsPerformanceModalOpen] = useState(false);
  const [stateList, setStateList] = useState<{ id: number; name: string }[]>(
    []
  );
  const [selectedState, setSelectedState] = useState("");
  const [isNPIModalOpen, setIsNPIModalOpen] = useState(false);
  const [isUseFullLinksModalOpen, setIsUseFullLinksModalOpen] = useState(false);
  const [rEImageActiveTab, setREImageActiveTab] = useState(0);
  const [holidayUpdateData, setHolidayUpdateData] = useState({});
  const [birthdayWorkAnniversaries, setBirthdayWorkAnniversaries] = useState<
    BirthdayWorkAnniversaries[]
  >([]);
  const [selectedBirthAnniversaryFilter, setSelectedBirthAnniversaryFilter] =
    useState("Today");
  const [selectAllCheckedBirthday, setSelectAllCheckedBirthday] =
    useState(false);
  const [selectAllCheckedAnniversary, setSelectAllCheckedAnniversary] =
    useState(false);
  const [spaceUpdateData, setSpaceUpdateData] = useState<Spaces>({} as Spaces);

  const [learningData, setLearningData] = useState<
    { id: number; title: string; logoUrl: string; link: string }[]
  >([]);
  const [learningDevelopmentUpdateData, setLearningDevelopmentUpdateData] =
    useState<LearningDevelopmentFormDataState>(
      {} as LearningDevelopmentFormDataState
    );
  const [leadershipTypesList, setLeadershipTypesList] = useState<
    { id: number; type: string }[]
  >([]);
  const [leadershipCornerData, setLeadershipCornerData] = useState<
    LeadershipCornerListData[]
  >([]);
  const [fullLeadershipCornerData, setFullLeadershipCornerData] = useState<
    LeadershipCornerState[]
  >([]);
  const [leadershipCornerUpdateData, setLeadershipCornerUpdateData] =
    useState<LeadershipCornerState>({} as LeadershipCornerState);

  const [wallpaperData, setWallpaperData] = useState<Wallpaper[]>([]);
  const [wallpaperUpdateData, setWallpaperUpdateData] =
    useState<Wallpaper | null>(null);
  const [hoveredBirthAnnyIndex, setHoveredBirthAnnyIndex] = useState<
    number | null
  >(null);
  const [hoveredNewJoinerIndex, setHoveredNewJoinerIndex] = useState<
    number | null
  >(null);
  const [hoveredRandRIndex, setHoveredRandRIndex] = useState<number | null>(
    null
  );
  const [sliderDuration, setSliderDuration] = useState(5000); /// default 5 second for Banner slider
  const [jobPostings, setJobPostings] = useState<JobPosting[]>([]);
  const [performanceManagementList, setPerformanceManagementList] = useState<
    PerformanceManagementList[]
  >([]);
  const [updatepPerformanceManagement, setUpdatePerformanceManagement] =
    useState<PerformanceManagementList>({});
  const [reSocialList, setReSocialList] = useState<RESocialList[]>([]);
  const [updatepReSocial, setUpdateReSocial] = useState<RESocialList>({});
  const [selectedOpenRoadFilter, setSelectedOpenRoadFilter] = useState("All");
  const [openRoadTypesList, setOpenRoadTypesList] = useState<
    { id: number; type: string }[]
  >([]);
  const [openRoadData, setopenRoadData] = useState<openRoadListData[]>([]);
  const [fullopenRoadData, setFullopenRoadData] = useState<openRoadState[]>([]);
  const [openRoadUpdateData, setOpenRoadUpdateData] = useState<openRoadState>(
    {} as openRoadState
  );
  const [rewardsRecognitionData, setRewardsRecognitionData] = useState<
    RewardsRecognitionDataData[]
  >([]);
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [isYouTubeVideo, setIsYouTubeVideo] = useState(false);
  const [videoURL, setVideoURL] = useState("");
  const [fileTitle, setFileTitle] = useState("");

  const [motorcycleData, setMotorcycleData] = useState<OurMotorCycle[]>([]);
  const [updateMotorcycleData, setUpdateMotorcycleData] =
    useState<OurMotorCycle>({});
  const [NPIData, setNPIData] = useState<NPI[]>([]);
  const [NPIUpdateData, setNPIUpdateData] = useState<NPI>({});
  const [socialMissionTypesList, setSocialMissionTypesList] = useState<
    { id: number; type: string }[]
  >([]);
  const [socialMissionData, setSocialMissionData] = useState<
    SocialMissionListData[]
  >([]);
  const [fullSocialMissionData, setFullSocialMissionData] = useState<
    SocialMissionState[]
  >([]);
  const [socialMissionUpdateData, setSocialMissionUpdateData] =
    useState<SocialMissionState>({} as SocialMissionState);
  const [selectedSocialMissionFilter, setSelectedSocialMissionFilter] =
    useState("All");
  const [eventsTypesList, setEventsTypesList] = useState<
    { id: number; type: string }[]
  >([]);
  const [eventsData, setEventsData] = useState<SocialMissionListData[]>([]);
  const [fullEventsData, setFullEventsData] = useState<SocialMissionState[]>(
    []
  );
  const [eventsUpdateData, setEventsUpdateData] = useState<EventsUpdateData>(
    {}
  );
  const [selectedEventsFilter, setSelectedEventsFilter] = useState("All");
  const [useFullLinksData, setUseFullLinksData] = useState<UseFullLinks[]>([]);
  const [useFullLinksUpdateData, setUseFullLinksUpdateData] =
    useState<UseFullLinks>({});
  const [employeeIReferralData, setEmployeeIReferralData] = useState<
    EmployeeIReferralList[]
  >([]);
  const [updatepEmployeeIRefer, setUpdatepEmployeeIRefer] =
    useState<EmployeeIReferListData>({});
  const [dashboardSearchModal, setDashboardSearchModal] = useState(false);
  const [dashboardSearchData, setDashboardSeachData] = useState<
    SearchResultItem[]
  >([]);

  const dashboardSearchKey = useAppSelector(
    (state) => state.dashboardReducer.dashboardSearch
  );
  const [isAwardAcceptedModalOpen, setIsAwardAcceptedModalOpen] =
    useState(false);
  const [isRewardAcceptanceFormOpen, setIsRewardAcceptanceFormOpen] =
    useState(true);
  const [isREImagineAccessModalOpen, setIsREImagineAccessModalOpen] =
    useState(false);
  const dropDownNewData = { id: "All", type: "All" };
  const [rewardMessage, setRewardMessage] = useState<string>("");
  const [reImagineData, setREImagineData] = useState<REImagingDataList[]>([]);
  const [reImagineUpdateData, setREImagineUpdateData] =
    useState<REImagingUpdateData>({});
  const [reImagineAccessData, setREImagineAccessData] =
    useState<REImagingUpdateData>({});
  const [rewardAcceptanceFormData, setRewardAcceptanceFormData] =
    useState<RewardsRecognitionDataData | null>(null);
  const [selectAllCheckedMap, setSelectAllCheckedMap] = useState<{
    [key: number]: boolean;
  }>({});
  const [isLoadingWishes, setIsLoadingWishes] = useState<{
    [key: number]: boolean;
  }>({});
  const [showTabsRR, setShowTabsRR] = useState(false);
  const sendTransformRRWishListData = (
    responseList: {
      userId: string;
      crossFunctionalTypeId: number;
      awardId: number;
    }[]
  ) => {
    return responseList.map((item) => ({
      userId: item.userId,
      crossFunctionalTypeId: item.crossFunctionalTypeId,
      wishType: 4,
      awardId: item.awardId,
    }));
  };

  const handleSendWishesRandR = async (
    awardId: number,
    data: RewardsRecognitionDataData[]
  ) => {
    const selectedUsers = data
      .filter((x) => x.awardId === awardId)
      .flatMap((item) =>
        item.lstRewardAndRecognizationNomination_Members
          .filter((user) => user.isChecked)
          .map((user) => ({
            userId: user.userId,
            crossFunctionalTypeId: item.crossFunctionalTypeId || 0,
            wishType: 4,
            awardId,
          }))
      );

    if (selectedUsers.length === 0) {
      showToast("Please select at least one person to send wishes.", "error");
      return;
    }

    setIsLoadingWishes((prev) => ({ ...prev, [awardId]: true }));

    try {
      const inputData = sendTransformRRWishListData(selectedUsers);
      const response = await dashboardService.postRandRUserSendWishesAPI(
        inputData
      );
      const finalResponse = response.data;

      if (finalResponse.success) {
        showToast(finalResponse.message, "success");

        // Clear selection
        const updated = data.map((item) =>
          item.awardId === awardId
            ? {
                ...item,
                lstRewardAndRecognizationNomination_Members:
                  item.lstRewardAndRecognizationNomination_Members.map(
                    (user) => ({
                      ...user,
                      isChecked: false,
                    })
                  ),
              }
            : item
        );
        setRewardsRecognitionData(updated);
        setSelectAllCheckedMap((prev) => ({ ...prev, [awardId]: false }));
      }
    } catch (error) {
      console.error("Error sending wishes:", error);
    } finally {
      setIsLoadingWishes((prev) => ({ ...prev, [awardId]: false }));
    }
  };

  const handleSelectAllChangeRR = (
    checked: boolean,
    awardId: number,
    data: RewardsRecognitionDataData[],
    setData: (data: RewardsRecognitionDataData[]) => void
  ) => {
    const updated = data.map((item) =>
      item.awardId === awardId
        ? {
            ...item,
            lstRewardAndRecognizationNomination_Members:
              item.lstRewardAndRecognizationNomination_Members.map((user) => ({
                ...user,
                isChecked: checked,
              })),
          }
        : item
    );
    setData(updated);
  };

  // Award Accepted Modal Open condition
  useEffect(() => {
    const fetchRewardStatus = async () => {
      const searchParams = new URLSearchParams(location.search);
      const id = searchParams.get("id");
      const status = searchParams.get("status");

      if (location.pathname === "/dashboard" && id && status) {
        setIsAwardAcceptedModalOpen(true);
        setIsLoading(true);
        const inputData = { id, status };

        try {
          const response =
            await dashboardService.GetRewardAndRecognizationApproveRejectAPI(
              inputData
            );

          const finalResponse = response.data;

          if (finalResponse.success) {
            setRewardMessage(
              finalResponse.message || "Reward action completed."
            );
          } else {
            setRewardMessage("Something went wrong.");
          }
        } catch (error) {
          console.error("Error fetching reward status:", error);
          setRewardMessage("Error processing the request.");
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchRewardStatus();
  }, [location]);

  // REImagine AccessStatus Modal Open condition
  useEffect(() => {
    const fetchREImagineAceecsStatus = async () => {
      const searchParams = new URLSearchParams(location.search);
      const id = searchParams.get("requestId");
      const approvalId = searchParams.get("requestId");

      if (location.pathname === "/dashboard" && id && approvalId) {
        setIsREImagineAccessModalOpen(true);

        try {
          const response =
            await dashboardService.GetREImagineAceecsApproveRejectAPI(id);

          const finalResponse = response.data;

          if (finalResponse.success) {
            setRewardMessage(
              finalResponse.message || "REImagineAceecs action completed."
            );
            setREImagineAccessData(finalResponse.data);
          } else {
            setRewardMessage("Something went wrong.");
          }
        } catch (error) {
          console.error("Error fetching REImagineAceecs status:", error);
          setRewardMessage("Error processing the request.");
        }
      }
    };

    fetchREImagineAceecsStatus();
  }, [location]);

  // Reward And Recognition Status  Modal Open condition
  useEffect(() => {
    const fetchRewardAndRecognitionStatus = async () => {
      setIsRewardAcceptanceFormOpen(true);
      const searchParams = new URLSearchParams(location.search);
      const id = searchParams.get("RewardAndRecognitionId");
      if (location.pathname === "/dashboard" && id) {
        setIsRewardAcceptanceFormOpen(true);
        try {
          const response =
            await dashboardService.GetRewardAndRecognitionStatusAPI(id);
          const finalResponse = response.data;
          if (finalResponse.success) {
            setRewardAcceptanceFormData(finalResponse.data);
          }
        } catch (error) {
          console.error("Error fetching REImagineAceecs status:", error);
          setRewardMessage("Error processing the request.");
        }
      }
    };

    fetchRewardAndRecognitionStatus();
  }, [location]);

  useEffect(() => {
    fetchBannerImageList();
    fetchDurationObject();
    fetchStatesList();
    fetchSpaces();
    fetchLearningAndDevelopmentList();
    fetchLeadershipCornerDataList();
    fetchWallpapers();
    fetchNewJoiners(selectedFilter);
    fetchBirthdayWorkAnniversaries("Today");
    fetchInternalJobPostings();
    fetchPerformanceManagementList();
    fetchRESocialList();
    fetchOpenRoadDataList();
    fetchRewardAndRecognizationData();
    fetchMotorCycleData();
    fetchNPIData();
    fetchSocialMissionDataList();
    fetchEventsDataList();
    fetchUseFullLinksData();
    fetchEmployeeIReferralData();
    fetchREImagineDataList();
  }, []);

  useEffect(() => {
    const searchTime = setTimeout(() => {
      if (dashboardSearchKey !== "") {
        fetchDashboardSearchKeyData();
      }
    }, 500);

    return () => {
      clearTimeout(searchTime);
    };
  }, [dashboardSearchKey]);

  useEffect(() => {
    if (stateList.length > 0) {
      if (selectedState) {
        setSelectedState(selectedState);
      } else {
        setSelectedState(stateList[0].name);
      }
    }

    if (selectedState) {
      fetchHolidays();
    }
  }, [stateList, selectedState]);

  const handleOpenDeleteModal = (
    item:
      | Holiday
      | Spaces
      | LearningDevelopmentFormDataState
      | Wallpaper
      | LeadershipCornerState
      | JobPosting
      | RESocialList
      | openRoadListData
      | OurMotorCycle
      | NPI
      | UseFullLinks,

    type:
      | "holiday"
      | "space"
      | "learningDevelopment"
      | "wallpaper"
      | "LeadershipCorner"
      | "internalJobPosting"
      | "performanceManagement"
      | "OpenRoad"
      | "motorcycleData"
      | "NPI"
      | "socialMission"
      | "events"
      | "UseFullLinks"
      | "iReferral"
  ) => {
    setSelectedItem(item);
    setDeleteType(type);
    setIsDeleteModalOpen(true);
  };

  const handleDeleteData = async () => {
    if (!selectedItem || !deleteType) return;

    try {
      let response;

      switch (deleteType) {
        case "holiday":
          response = await dashboardService.deleteHolidaysDataAPI(
            (selectedItem as Holiday).holidayId!
          );
          break;
        case "space":
          response = await dashboardService.deleteSpacesDataAPI(
            (selectedItem as Spaces).id!
          );
          break;
        case "learningDevelopment":
          response = await dashboardService.deleteLearningDevelopmentDataAPI(
            (selectedItem as LearningDevelopmentFormDataState).id!
          );
          break;
        case "wallpaper":
          response = await dashboardService.deleteWallpaperDataAPI(
            (selectedItem as Wallpaper).id!
          );
          break;
        case "LeadershipCorner":
          response = await dashboardService.deleteLeadershipCornerDataAPI(
            (selectedItem as LeadershipCornerState).id!
          );
          break;
        case "internalJobPosting":
          response = await dashboardService.deleteInternalJobPostingData(
            (selectedItem as JobPosting).id!
          );
          break;
        case "performanceManagement":
          response = await dashboardService.deletePerformanceManagementDataAPI(
            (selectedItem as PerformanceManagementList).id!
          );
          break;
        case "OpenRoad":
          response = await dashboardService.deleteOpenRoadDataAPI(
            (selectedItem as openRoadListData).id!
          );
          break;
        case "motorcycleData":
          response = await dashboardService.deleteMotorCycleData(
            (selectedItem as OurMotorCycle).id!
          );
          break;
        case "NPI":
          response = await dashboardService.deleteNPIData(
            (selectedItem as NPI).id!
          );
          break;
        case "socialMission":
          response = await dashboardService.deleteSocialMissionDataAPI(
            (selectedItem as SocialMissionState).id!
          );
          break;
        case "events":
          response = await dashboardService.deleteEventsDataAPI(
            (selectedItem as EventsListData).id!
          );
          break;
        case "UseFullLinks":
          response = await dashboardService.deleteUseFullLinksData(
            (selectedItem as UseFullLinks).id!
          );
          break;
        case "iReferral":
          response = await dashboardService.deleteEmployeeIReferralDataAPI(
            (selectedItem as EmployeeIReferListData).id!
          );
          break;
        default:
          return;
      }

      if (response?.data?.message) {
        showToast(response?.data?.message, "success");

        switch (deleteType) {
          case "holiday":
            fetchHolidays();
            break;
          case "space":
            fetchSpaces();
            break;
          case "learningDevelopment":
            fetchLearningAndDevelopmentList();
            break;
          case "wallpaper":
            fetchWallpapers();
            break;
          case "LeadershipCorner":
            fetchLeadershipCornerDataList();
            break;
          case "internalJobPosting":
            fetchInternalJobPostings();
            break;
          case "performanceManagement":
            fetchPerformanceManagementList();
            break;
          case "OpenRoad":
            fetchOpenRoadDataList();
            break;
          case "motorcycleData":
            fetchMotorCycleData();
            break;
          case "NPI":
            fetchNPIData();
            break;
          case "socialMission":
            fetchSocialMissionDataList();
            break;
          case "events":
            fetchEventsDataList();
            break;
          case "UseFullLinks":
            fetchUseFullLinksData();
            break;
          case "iReferral":
            fetchEmployeeIReferralData();
            break;
        }
      }
    } catch (error) {
      showToast(`Failed to delete ${deleteType}`, "error");
    } finally {
      setIsDeleteModalOpen(false);
      setSelectedItem(null);
      setDeleteType(null);
    }
  };

  //// Dashboard Key Search data with Username, email and User code
  const fetchDashboardSearchKeyData = async () => {
    const payload = {
      search: dashboardSearchKey,
    };

    try {
      const response = await dashboardService.dashboardKeySearchAPI(payload);
      const finalResponse = response.data.data;
      if (finalResponse.length > 0) {
        setDashboardSeachData(finalResponse);
        setTimeout(() => {
          setDashboardSearchModal(true);
        }, 300);
      } else {
        setDashboardSeachData([]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Function to fetch state names
  const fetchBannerImageList = async () => {
    try {
      const response = await dashboardService.getBannerListAPI();
      const finalResponse = response?.data?.data;
      if (finalResponse.length > 0) {
        setBannerImageList(finalResponse);
      } else {
        setBannerImageList([]);
      }
    } catch (error) {
      console.error("Error fetching Banner Image:", error);
    }
  };
  // Fetch Duration object for Banner
  const fetchDurationObject = async () => {
    try {
      const response = await dashboardService.getDurationtimeAPI();
      const finalReponse = response?.data?.data;
      if (finalReponse.value !== "") {
        let tempDuration = 0;
        switch (finalReponse.value) {
          case "5seconds":
            tempDuration = 5000;
            break;
          case "10seconds":
            tempDuration = 10000;
            break;
          case "15seconds":
          default:
            tempDuration = 15000;
            break;
        }
        setSliderDuration(tempDuration);
      } else {
        setSliderDuration(5000);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  //// fetch New Joiners User list
  const fetchNewJoiners = async (filter: string) => {
    const { startDate, endDate } = getDateRangeFilter(filter);

    const payload = {
      startDate: startDate,
      endDate: endDate,
      locationCode: "",
    };

    try {
      const response = await dashboardService.postNewJoinersAPI(payload);
      const finalResponse = response.data.data;
      if (finalResponse.length > 0) {
        finalResponse.forEach((el: { isChecked: boolean }) => {
          el.isChecked = false;
        });
        setNewJoiners(finalResponse);
      } else {
        setNewJoiners([]);
      }
    } catch (error) {
      console.error("Error fetching new joiners:", error);
    }
  };

  //// fetch Birthdays and Work Anniversaries list
  const fetchBirthdayWorkAnniversaries = async (filter: string) => {
    const { startDate, endDate } = getDateRangeFilter(filter);

    const payload = {
      startDate: startDate,
      endDate: endDate,
      locationCode: "",
    };

    try {
      const response = await dashboardService.postBirthdayWorkAnniversariesAPI(
        payload
      );
      const finalResponse = response.data.data;
      if (finalResponse.length > 0) {
        finalResponse.forEach((el: { isChecked: boolean }) => {
          el.isChecked = false;
        });
        setBirthdayWorkAnniversaries(finalResponse);
      } else {
        setBirthdayWorkAnniversaries([]);
      }
    } catch (error) {
      console.error(
        "Error fetching Birthdays and Work Anniversaries List:",
        error
      );
    }
  };

  const transformNewJoinersToUserWishesState = (
    data: NewJoiner[]
  ): UserWishesState[] => {
    return data.map((el) => ({
      userId: el.userId || "",
      employeeName: el.name || "",
      eventDate: el.eventDate || "",
      locationId: el.locationCode ? Number(el.locationCode) : undefined,
      imageUrl: el.imageUrl || "",
      isChecked: el.isChecked || false,
      isBirthDay: false,
      isAnniversary: false,
    }));
  };

  const sendTransformWishListData = (
    responseList: UserWishesState[]
  ): FormattedUserWishesEvent[] => {
    return responseList
      .filter((item) => item.isChecked)
      .map((item) => ({
        userId: item.userId,
        eventDate: item.eventDate,
        wishType: item.isBirthDay ? 1 : item.isAnniversary ? 2 : 3,
      }));
  };

  const checkUserWishesValidation = (type: string): boolean => {
    if (
      type === "Birthday" &&
      birthdayWorkAnniversaries.every((x) => !x.isChecked)
    ) {
      showToast(
        "Please select at least one user before sending wishes.",
        "error"
      );
      return false;
    }
    if (type === "New Joiners" && newJoiners.every((x) => !x.isChecked)) {
      showToast(
        "Please select at least one user before sending wishes.",
        "error"
      );
      return false;
    }
    return true;
  };

  //// send Birthdays and Work Anniversaries list
  const handleUserSendWishes = async (wishType: string) => {
    if (!checkUserWishesValidation(wishType)) return;

    let formattedList = [];

    if (wishType === "Birthday") {
      formattedList = birthdayWorkAnniversaries.filter(
        (item) => item.isChecked
      );
    } else {
      const selectedNewJoiners = newJoiners.filter((item) => item.isChecked);

      formattedList = transformNewJoinersToUserWishesState(selectedNewJoiners);
    }

    if (formattedList.length === 0) {
      showToast("Please select at least one item to send wishes.", "error");
      return;
    }

    wishType === "Birthday"
      ? setIsBirthdayLoader(true)
      : setIsNewJoinerLoader(true);

    const inputData = sendTransformWishListData(formattedList);
    try {
      const response = await dashboardService.postUserSendWishesAPI(inputData);
      const finalResponse = response.data;
      if (finalResponse.success) {
        showToast(finalResponse.message, "success");
        if (wishType === "Birthday") {
          setIsBirthdayLoader(false);
          setBirthdayWorkAnniversaries((prev) =>
            prev.map((el) => ({ ...el, isChecked: false }))
          );
          setSelectAllCheckedBirthday(false);
          setSelectAllCheckedAnniversary(false);
          fetchBirthdayWorkAnniversaries("Today");
          fetchNewJoiners(selectedFilter);
        } else {
          setIsNewJoinerLoader(false);
          setNewJoiners((prev) =>
            prev.map((el) => ({ ...el, isChecked: false }))
          );
          setSelectAllNewJoinersChecked(false);
          fetchNewJoiners(selectedFilter);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Function to fetch state names
  const fetchStatesList = async () => {
    try {
      const response = await dashboardService.getStatesAPI();
      if (response?.data?.success && response?.data?.data) {
        const formattedStates = response.data.data.map(
          (state: { locationId: number; locationName: string }) => ({
            id: state.locationId,
            name: state.locationName,
          })
        );
        setStateList(formattedStates);
        if (selectedState === formattedStates[0]?.id) {
          setSelectedState(selectedState);
        } else {
          setSelectedState(formattedStates[0]?.id || 0);
        }
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };
  // Fetch to Leadership corner Type List
  const fetchLeadershipTypeList = async () => {
    try {
      const response = await dashboardService.getLeadershipTypeAPI();
      const finalResponse = response?.data?.data;
      if (finalResponse.length > 0) {
        finalResponse.unshift(dropDownNewData);
        setLeadershipTypesList(finalResponse);
      } else {
        setLeadershipTypesList([]);
      }
    } catch (error) {
      console.error("Error feching Types:", error);
    }
  };

  //// fetch holiday data
  const fetchHolidays = async () => {
    const selectedStateObj = stateList.find(
      (state) => state.name === selectedState
    );
    const payload = {
      startDate: dayjs().toISOString(),
      endDate: dayjs()
        .add(1, "year")
        .set("month", 2)
        .set("date", 31)
        .toISOString(),
      locationCode: "",
      stateId: selectedStateObj ? selectedStateObj.id : 0,
    };

    try {
      const { data } = await dashboardService.postHolidaysAPI(payload);
      if (data?.statusCode === 200 && Array.isArray(data.data)) {
        setHolidays(data.data);
      } else {
        setHolidays([]);
      }
    } catch (error) {
      console.error("Error fetching holidays:", error);
    }
  };

  // Function to fetch Learning And Development
  const fetchLearningAndDevelopmentList = async () => {
    try {
      const response = await dashboardService.getLearningAndDevelopmentAPI();
      if (response?.data?.success && response?.data?.data) {
        setLearningData(response.data.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  // Function to fetch Leadership corner data
  const fetchLeadershipCornerDataList = async () => {
    try {
      const response = await dashboardService.getLeadershipCornerDataAPI("");
      if (response?.data?.data.length > 0) {
        setLeadershipCornerData(response?.data?.data);
        setFullLeadershipCornerData(response?.data?.data);
        fetchLeadershipTypeList();
      } else {
        setLeadershipCornerData([]);
        setFullLeadershipCornerData([]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  /// APi called for delete Learning Development data
  const fetchWallpapers = async () => {
    try {
      const response = await dashboardService.getWallpaperAPI();
      if (response?.data?.success && response?.data?.data) {
        setWallpaperData(response.data.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  //// fetch the Internal Job Posting data list
  const fetchInternalJobPostings = async () => {
    try {
      const response = await dashboardService.getInternalJobPostingAPI();
      if (response?.data?.success && response?.data?.data) {
        setJobPostings(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching job postings:", error);
    }
  };

  //// fetch the Performance Management data list
  const fetchPerformanceManagementList = async () => {
    try {
      const response = await dashboardService.getPerformanceManagementAPI();
      if (response?.data?.success && response?.data?.data.length > 0) {
        setPerformanceManagementList(response.data.data);
      } else {
        setPerformanceManagementList([]);
      }
    } catch (error) {
      console.error("Error-:", error);
    }
  };
  //// fetch the RE Social data list
  const fetchRESocialList = async () => {
    try {
      const response = await dashboardService.getRESocialAPI();
      if (response?.data?.success && response?.data?.data.length > 0) {
        setReSocialList(response.data.data);
      } else {
        setReSocialList([]);
      }
    } catch (error) {
      console.error("Error-:", error);
    }
  };

  // Function to fetch Open Road data
  const fetchOpenRoadDataList = async () => {
    try {
      const response = await dashboardService.getOpenRoadDataAPI("");
      if (response?.data?.data.length > 0) {
        setopenRoadData(response?.data?.data);
        setFullopenRoadData(response?.data?.data);
        fetchOpenRoadTypeList();
      } else {
        setopenRoadData([]);
        setFullopenRoadData([]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Fetch to Leadership corner Type List
  const fetchOpenRoadTypeList = async () => {
    try {
      const response = await dashboardService.getOpenRoadTypeAPI();
      const finalResponse = response?.data?.data;
      if (finalResponse.length > 0) {
        finalResponse.unshift(dropDownNewData);
        setOpenRoadTypesList(finalResponse);
      } else {
        setOpenRoadTypesList([]);
      }
    } catch (error) {
      console.error("Error feching Types:", error);
    }
  };
  //// fetch Reward And Recognization list
  const fetchRewardAndRecognizationData = async () => {
    const payload = {
      startDate: financialYear.startDate,
      endDate: financialYear.endDate,
    };

    try {
      const response = await dashboardService.GetRewardAndRecognizationDataAPI(
        payload
      );
      const finalResponse = response.data.data;
      if (finalResponse.length > 0) {
        setRewardsRecognitionData(finalResponse);
      } else {
        setRewardsRecognitionData([]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Function to fetch Social Mission data
  const fetchSocialMissionDataList = async () => {
    try {
      const response = await dashboardService.getSocialMissionDataAPI("");
      if (response?.data?.data.length > 0) {
        setSocialMissionData(response?.data?.data);
        setFullSocialMissionData(response?.data?.data);
        fetchSocialMissionTypeList();
      } else {
        setSocialMissionData([]);
        setFullSocialMissionData([]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Fetch to Social Mission Type List
  const fetchSocialMissionTypeList = async () => {
    try {
      const response = await dashboardService.getSocialMissionTypeAPI();
      const finalResponse = response?.data?.data;
      if (finalResponse.length > 0) {
        finalResponse.unshift(dropDownNewData);
        setSocialMissionTypesList(finalResponse);
      } else {
        setSocialMissionTypesList([]);
      }
    } catch (error) {
      console.error("Error feching Types:", error);
    }
  };

  // Function to fetch Events data
  const fetchEventsDataList = async () => {
    try {
      const response = await dashboardService.getEventsDataAPI("");
      if (response?.data?.data.length > 0) {
        setEventsData(response?.data?.data);
        setFullEventsData(response?.data?.data);
        fetchEventsTypeList();
      } else {
        setEventsData([]);
        setFullEventsData([]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Fetch to Events Type List
  const fetchEventsTypeList = async () => {
    try {
      const response = await dashboardService.getEventsTypeAPI();
      const finalResponse = response?.data?.data;
      if (finalResponse.length > 0) {
        finalResponse.unshift(dropDownNewData);
        setEventsTypesList(finalResponse);
      } else {
        setEventsTypesList([]);
      }
    } catch (error) {
      console.error("Error feching Types:", error);
    }
  };

  const fetchUseFullLinksData = async () => {
    try {
      const { data } = await dashboardService.getUseFullLinksData();
      if (data?.statusCode === 200 && Array.isArray(data.data)) {
        setUseFullLinksData(data.data);
      } else {
        setUseFullLinksData([]);
      }
    } catch (error) {
      console.error("Error fetching spaces:", error);
    }
  };

  // Function to fetch Employee IReferral data
  const fetchEmployeeIReferralData = async () => {
    try {
      const response = await dashboardService.getEmployeeIReferralDataAPI();
      if (response?.data?.success && response?.data?.data) {
        setEmployeeIReferralData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching job postings:", error);
    }
  };

  const handleYesterdayCheckboxClick = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsYesterdayChecked(event.target.checked);
    if (event.target.checked) {
      setSelectAllCheckedAnniversary(false);
      setSelectAllCheckedBirthday(false);
      fetchBirthdayWorkAnniversaries("Yesterday");
    } else {
      fetchBirthdayWorkAnniversaries(selectedBirthAnniversaryFilter);
    }
  };

  //// fetch REImagine list
  const fetchREImagineDataList = async () => {
    const payload = {
      pageNo: 1,
      pageSize: 10,
      startDate: financialYear.startDate,
      endDate: financialYear.endDate,
      status: null,
      isIdeathon: null,
      isInitiated: false,
      requestedBy: null,
      gender: null,
    };

    try {
      const response = await dashboardService.GetREImagineDataAPI(payload);
      const finalResponse = response.data.data;
      if (finalResponse.length > 0) {
        setREImagineData(finalResponse);
      } else {
        setREImagineData([]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const allTheHelpYouNeedTab = [
    { title: "REImagine in brief", icon: note },
    { title: "Accept the idea", icon: trendUp },
    { title: "Ask for a suggestion", icon: clipboardTick },
    { title: "Delegate the idea", icon: clipboardClose },
    { title: "Reject the idea", icon: infoCircle },
  ];

  const handleInternalJobOpen = () => {
    setInternalJobOpen(true);
    setJobUpdateData({});
  };

  const handleInternalJobSaveData = () => {
    handleClose();
    fetchInternalJobPostings();
  };
  const handleEditInternalJobData = (JobPostingData: JobPosting) => {
    setInternalJobOpen(true);
    setJobUpdateData(JobPostingData);
  };
  const handleClose = () => {
    setInternalJobOpen(false);
    setReSocialOpen(false);
    setIReferOpen(false);
    setOpenRoadOpen(false);
  };
  const handleBannerImageModalOpen = () => {
    setBannerImageMdl(true);
  };

  const handleBannerImageModalClose = () => {
    setBannerImageMdl(false);
  };

  const fetchSpaces = async () => {
    try {
      const response = await dashboardService.getSpaceCardDataAPI();
      if (response?.data?.success && response?.data?.data) {
        setSpaces(response.data.data);
      } else {
        setSpaces([]);
      }
    } catch (error) {
      console.error("Error fetching spaces:", error);
    }
  };

  const handleEditSpaceData = (space: Spaces) => {
    setSpaceUpdateData(space);
    setSpaceMdl(true);
    fetchSpaces();
  };
  const handleSpaceModalOpen = () => {
    setSpaceMdl(true);
    setSpaceUpdateData({
      id: null,
      title: "",
      logoUrl: "",
      logo: null,
      spaceLink: "",
    });
  };
  const handleSpaceSaveData = () => {
    handleClose();
    fetchSpaces();
  };
  const handleCloseSpaceModal = () => {
    setSpaceMdl(false);
  };
  // space card integration code end

  const handleHolidayModalOpen = () => {
    setHolidayMdl(true);
    setHolidayUpdateData({});
  };
  const handleHolidayModalClose = () => {
    setHolidayMdl(false);
    setHolidayUpdateData({});
  };
  const handleReSocialOpen = () => {
    setUpdateReSocial({});
    setReSocialOpen(true);
  };

  const handleReSocialSaveData = () => {
    fetchRESocialList();
    setReSocialOpen(false);
  };
  const handleIReferOpen = () => {
    setUpdatepEmployeeIRefer({});
    setIReferOpen(true);
  };

  const handleIReferSaveData = () => {
    fetchEmployeeIReferralData();
    setIReferOpen(false);
  };
  const handleOpenRoadModalOpen = () => {
    setOpenRoadOpen(true);
    setOpenRoadUpdateData({
      id: null,
      title: "",
      type: "",
      youtubeUrl: "",
      filePath: "",
      thumbNailPath: "",
      isYouTubeLink: false,
    });
  };

  const handleOpenRoadSaveData = () => {
    handleClose();
    fetchOpenRoadDataList();
  };
  const handleSocialMissionOpen = () => {
    setSocialMissionOpen(true);
    setSocialMissionUpdateData({
      id: null,
      title: "",
      type: "",
      youtubeUrl: "",
      filePath: "",
      isYouTubeLink: false,
    });
  };
  const handleSocialMissionClose = () => {
    setSocialMissionOpen(false);
    fetchSocialMissionDataList();
  };

  const handleSocialMissionSaveData = () => {
    handleClose();
  };

  const handleLeadershipCornerModalOpen = () => {
    setLeadershipCornerMdl(true);
    setLeadershipCornerUpdateData({
      id: null,
      title: "",
      type: "",
      youtubeUrl: "",
      filePath: "",
      thumbNailPath: "",
      isYouTubeLink: false,
    });
  };

  const handleCloseLeadershipCornerModal = () => {
    setLeadershipCornerMdl(false);
  };

  const handleGetEditLeadershipCornerData = (item: LeadershipCornerState) => {
    setLeadershipCornerMdl(true);
    setLeadershipCornerUpdateData(item);
  };
  const handleEditHolidayData = (holidayData: Holiday) => {
    setHolidayMdl(true);
    setHolidayUpdateData(holidayData);
  };
  const handleREImagineModalOpen = () => {
    setIsREImagineModalOpen(true);
    setREImagineUpdateData({});
  };
  const handleRewardAndRecognitionModalOpen = () => {
    setRewardAndRecognitionModalOpen(true);
  };
  const handleRewardAndRecognitionSaveData = () => {
    fetchRewardAndRecognizationData();
    setRewardAndRecognitionModalOpen(false);
  };
  const handleRewardAndRecognitionModalClose = () => {
    setRewardAndRecognitionModalOpen(false);
  };

  const handleREImagineModalClose = () => {
    setIsREImagineModalOpen(false);
  };

  const handleREImagineSaveData = () => {
    setIsREImagineModalOpen(false);
    fetchREImagineDataList();
  };
  const handleLearningDevelopmentModalOpen = () => {
    setLearningDevelopmentMdl(true);
    setLearningDevelopmentUpdateData({
      id: null,
      title: "",
      logoUrl: "",
      logo: null,
      link: "",
    });
  };
  const handleLearningDevelopmentModalClose = () => {
    setLearningDevelopmentMdl(false);
  };
  const handleEditLearningDevelopmentData = (
    learningUpdateData: LearningDevelopmentFormDataState
  ) => {
    setLearningDevelopmentMdl(true);
    setLearningDevelopmentUpdateData(learningUpdateData);
  };

  const handleBannerImageSaveData = () => {
    setBannerImageMdl(false);
    fetchBannerImageList();
  };

  const handleLeadershipCornerSaveData = () => {
    handleCloseLeadershipCornerModal();
    fetchLeadershipCornerDataList();
  };

  const handleHolidaySaveData = () => {
    handleHolidayModalClose();
    setTimeout(() => {
      fetchHolidays();
    }, 300);
  };
  const handleLearningDevelopmentSaveData = () => {
    setLearningDevelopmentMdl(false);
    setTimeout(() => {
      fetchLearningAndDevelopmentList();
    }, 300);
  };

  // Wallpaper Modal
  const handleWallpaperModalOpen = () => setIsWallpaperModalOpen(true);
  const handleWallpaperModalClose = () => {
    setWallpaperUpdateData(null);
    setIsWallpaperModalOpen(false);
  };
  const handleSaveWallpaperModal = () => {
    setIsWallpaperModalOpen(false);
    fetchWallpapers();
  };
  const handleEditWallpaper = (wallpaper: Wallpaper) => {
    setWallpaperUpdateData(wallpaper);
    setIsWallpaperModalOpen(true);
  };

  // Events Modal
  const handleVideoVaultModalOpen = () => {
    setIsVideoVaultModalOpen(true);
    setEventsUpdateData({});
  };
  const handleVideoVaultModalClose = () => {
    setIsVideoVaultModalOpen(false);
  };

  const handleSaveVideoVaultModal = () => {
    fetchEventsDataList();
    setIsVideoVaultModalOpen(false);
  };

  // Performance Management Modal Handlers
  const handlePerformanceModalOpen = () => {
    setIsPerformanceModalOpen(true);
  };
  const handlePerformanceModalClose = () => {
    setIsPerformanceModalOpen(false);
  };
  const handleSavePerformanceModal = () => {
    fetchPerformanceManagementList();
    setIsPerformanceModalOpen(false);
  };
  const handleNPIModalClose = () => {
    setIsNPIModalOpen(false);
  };
  const handleNPIModalOpen = () => {
    setIsNPIModalOpen(true);
    setNPIUpdateData({});
  };
  const handleSaveNPIModal = () => {
    fetchNPIData();
    setIsNPIModalOpen(false);
  };

  const handlePerformanceUpdateData = (data: PerformanceManagementList) => {
    setUpdatePerformanceManagement(data);
    setIsPerformanceModalOpen(true);
  };
  const handleRESocialUpdateData = (data: RESocialList) => {
    setUpdateReSocial(data);
    setReSocialOpen(true);
  };
  const handleGetEditOpenRoadData = (item: openRoadState) => {
    setOpenRoadOpen(true);
    setOpenRoadUpdateData(item);
  };
  const handleGetEditSocialMissionData = (item: SocialMissionState) => {
    setSocialMissionOpen(true);
    setSocialMissionUpdateData(item);
  };
  const handleGetEditEventsData = (item: SocialMissionState) => {
    setIsVideoVaultModalOpen(true);
    setEventsUpdateData(item);
  };

  const handleCheckLeadershipVideo = (
    isYouTubeLink: boolean,
    youtubeUrl?: string,
    filePath?: string,
    title?: string
  ) => {
    setVideoModalOpen(true);
    setIsYouTubeVideo(isYouTubeLink);
    setFileTitle(title ?? "");
    setVideoURL(isYouTubeLink ? youtubeUrl ?? "" : filePath ?? "");
  };

  // Our MotorCycle Function------
  const handleOurMotorcycleOpen = () => {
    setIsOurMotorcycleOpen(true);
    setUpdateMotorcycleData({});
  };
  const handleOurMotorcycleClose = () => setIsOurMotorcycleOpen(false);

  const handleSaveOurMotorcycle = () => {
    setIsOurMotorcycleOpen(false);
    fetchMotorCycleData();
    setMotorcycleData([]);
  };
  const fetchMotorCycleData = async () => {
    try {
      const { data } = await dashboardService.getMotorCycleData();
      if (data?.statusCode === 200 && Array.isArray(data.data)) {
        setMotorcycleData(data.data);
      } else {
        setMotorcycleData([]);
      }
    } catch (error) {
      console.error("Error fetching spaces:", error);
    }
  };
  const handleMotorcycleUpdateData = (data: OurMotorCycle) => {
    setUpdateMotorcycleData(data);
    setIsOurMotorcycleOpen(true);
  };
  // Fetch UseFullLinks data
  const fetchNPIData = async () => {
    try {
      const { data } = await dashboardService.getNPIData();
      if (data?.statusCode === 200 && Array.isArray(data.data)) {
        setNPIData(data.data);
      } else {
        setNPIData([]);
      }
    } catch (error) {
      console.error("Error fetching spaces:", error);
    }
  };
  const handleNPIUpdateData = (data: NPI) => {
    setNPIUpdateData(data);
    setIsNPIModalOpen(true);
  };

  // UseFullLinks Modal Handlers
  const handleUseFullLinksModalOpen = () => {
    setIsUseFullLinksModalOpen(true);
    setUseFullLinksUpdateData({});
  };
  const handleUseFullLinksModalClose = () => {
    setIsUseFullLinksModalOpen(false);
  };
  const handleSaveUseFullLinksModal = () => {
    fetchUseFullLinksData();
    setIsUseFullLinksModalOpen(false);
  };

  //// Edit User Full link modal with data
  const handleUseFullLinksUpdateData = (data: UseFullLinks) => {
    setUseFullLinksUpdateData(data);
    setIsUseFullLinksModalOpen(true);
  };
  //// Edit Employee IRefer Modal open with data
  const handleEditEmployeeIReferData = (iReferData: EmployeeIReferListData) => {
    setIReferOpen(true);
    setUpdatepEmployeeIRefer(iReferData);
  };

  const handleDashboardSearchClose = () => {
    setDashboardSearchModal(false);
    dispatch(setDashboardSearchKey(""));
  };

  //// handle REImagine Modal Open with Update data
  const handleREImagineUpdateModal = (updateData: REImagingUpdateData) => {
    setIsREImagineModalOpen(true);
    setREImagineUpdateData(updateData);
  };

  return (
    <>
      <div className="dashboard_sec">
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={8}>
              <BannerSlider
                addButton={hasBannerAccess}
                bannerImages={bannerImageList}
                bannerImgLogo={bannerImgLogo}
                sliderDuration={sliderDuration}
                handleBannerImageModalOpen={handleBannerImageModalOpen}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <MainCards
                title="Spaces"
                cardMaxHeight="230px"
                addButton={hasSpacesAccess}
                minHeight="300px"
                onButtonClick={handleSpaceModalOpen}
              >
                <Box p={1} paddingTop={0} paddingBottom={0}>
                  <>
                    {spaces.length > 0 ? (
                      <List disablePadding>
                        {spaces.map((item, index) => (
                          <ListItem
                            key={index}
                            sx={{
                              borderBottom: "1px solid #808080",
                              padding: "10px 5px",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <ListItemButton
                              component="a"
                              target="_blank"
                              href={item.spaceLink}
                              style={{
                                padding: "0px",
                                display: "flex",
                                alignItems: "center",
                                flex: 1,
                                textDecoration: "none",
                              }}
                            >
                              <Box
                                style={{
                                  width: 40,
                                  height: 40,
                                  // background:
                                  //   "linear-gradient(140deg, #EF2E24 0%, #DAAA00 100%)",
                                  // borderRadius: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginRight: 16,
                                }}
                              >
                                <img
                                  //  src={encodeURI(item.logoUrl)}
                                  src={item.logoUrl}
                                  alt="Logo"
                                  style={{
                                    width: 32,
                                    height: 32,
                                    objectFit: "cover",
                                  }}
                                />
                              </Box>
                              <Typography
                                className="f-14"
                                sx={{
                                  width: "75%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <CustomTooltip text={item.title} />
                              </Typography>
                            </ListItemButton>

                            {hasSpacesAccess && (
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <img
                                  src={EditIcon}
                                  alt="Edit"
                                  style={{ cursor: "pointer" }}
                                  width={20}
                                  height={20}
                                  onClick={() => handleEditSpaceData(item)}
                                />
                                <img
                                  src={DeleteIcon}
                                  alt="Delete"
                                  style={{
                                    marginLeft: "8px",

                                    cursor: "pointer",
                                  }}
                                  width={20}
                                  height={20}
                                  onClick={() =>
                                    handleOpenDeleteModal(item, "space")
                                  }
                                />
                              </Box>
                            )}
                          </ListItem>
                        ))}
                      </List>
                    ) : (
                      <Grid item xs={12}>
                        <Box className="noDataContainer">
                          <Typography>No Data Available</Typography>
                        </Box>
                      </Grid>
                    )}
                  </>
                </Box>
              </MainCards>
            </Grid>

            <Grid item xs={12} sm={6} md={8}>
              <MediaCardSection
                title="Leadership Corner"
                addButton={hasLeadershipCornerAccess}
                onButtonClick={handleLeadershipCornerModalOpen}
                dropdownOptions={leadershipTypesList}
                selectedValue={selectedLeadershipCornerFilter}
                onDropdownChange={(value) => {
                  const filteredData = fullLeadershipCornerData.filter(
                    (item) => item.type.toLowerCase() === value.toLowerCase()
                  );
                  setLeadershipCornerData(
                    value === "All" ? fullLeadershipCornerData : filteredData
                  );
                  setSelectedLeadershipCornerFilter(value);
                }}
              >
                <div>
                  <Grid container spacing={2}>
                    {leadershipCornerData.length > 0 ? (
                      <>
                        {leadershipCornerData.map((item, index) => {
                          const isYouTubeValid =
                            item.isYouTubeLink &&
                            item.youtubeUrl?.match(
                              /^https:\/\/(www\.youtube\.com|youtu\.be)\//
                            );
                          const hasFilePath =
                            item.filePath && item.filePath !== "";

                          return (
                            <Grid item xs={12} sm={6} md={3} key={index}>
                              <Card
                                elevation={1}
                                square
                                sx={{
                                  overflow: "hidden",
                                  border: "none",
                                  borderRadius: "3px",
                                  boxShadow: "none",
                                  position: "relative",
                                  backgroundColor: "#393939",
                                  color: "#ffffff",
                                }}
                              >
                                {(isYouTubeValid || hasFilePath) && (
                                  <Avatar
                                    onClick={() =>
                                      handleCheckLeadershipVideo(
                                        item.isYouTubeLink,
                                        item.youtubeUrl,
                                        item.filePath,
                                        item.title
                                      )
                                    }
                                    sx={{
                                      width: 40,
                                      height: 30,
                                      bgcolor: "rgba(0,0,0,0.8)",
                                      color: "white",
                                      position: "absolute",
                                      borderRadius: "25%",
                                      top: "41%",
                                      left: "50%",
                                      cursor: "pointer",
                                      transform: "translate(-50%, -50%)",
                                      transition: "background-color 0.3s ease",
                                      "&:hover": {
                                        bgcolor: "#FF0000",
                                      },
                                    }}
                                  >
                                    ▶
                                  </Avatar>
                                )}

                                <Box
                                  sx={{
                                    padding: "8px 8px 0px 8px",
                                    overflow: "hidden",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    if (!(isYouTubeValid || hasFilePath)) {
                                      window.open(item.youtubeUrl, "_blank");
                                    }
                                  }}
                                >
                                  <img
                                    src={item.thumbNailPath}
                                    alt={item.title}
                                    style={{
                                      width: "100%",
                                      height: "87px",
                                      objectFit: "cover",
                                      display: "block",
                                      backgroundColor: "#5D5D5D",
                                    }}
                                  />
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      padding: "8px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      width: "65%",
                                    }}
                                  >
                                    <Typography
                                      fontWeight="400"
                                      sx={{
                                        maxWidth: "100%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <CustomTooltip
                                        fontSize="12px"
                                        text={item.title}
                                      />
                                    </Typography>
                                  </Box>
                                  {hasLeadershipCornerAccess && (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <img
                                        src={EditIcon}
                                        alt="Add"
                                        style={{ cursor: "pointer" }}
                                        width={20}
                                        height={20}
                                        onClick={() =>
                                          handleGetEditLeadershipCornerData(
                                            item
                                          )
                                        }
                                      />
                                      <img
                                        src={DeleteIcon}
                                        alt="delete"
                                        style={{
                                          marginLeft: "8px",
                                          marginRight: "8px",
                                          cursor: "pointer",
                                        }}
                                        width={20}
                                        height={20}
                                        onClick={() =>
                                          handleOpenDeleteModal(
                                            item,
                                            "LeadershipCorner"
                                          )
                                        }
                                      />
                                    </Box>
                                  )}
                                </Box>
                              </Card>
                            </Grid>
                          );
                        })}
                      </>
                    ) : (
                      <Grid item xs={12}>
                        <Box className="noDataContainer">
                          <Typography>No Data Available</Typography>
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </div>
              </MediaCardSection>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <MainCards
                title="Holidays"
                addButton={hasHolidaysAccess}
                onButtonClick={handleHolidayModalOpen}
                dropdownOptions={stateList.map((state) => state.name)}
                selectedValue={selectedState}
                onDropdownChange={(value) => {
                  setSelectedState(value);
                }}
                minHeight="340px"
              >
                <Box p={1} pt={0} pb={0}>
                  {holidays.length > 0 ? (
                    <List disablePadding>
                      {holidays.map((item: Holiday, index) => (
                        <ListItem
                          key={index}
                          sx={{
                            borderBottom: "1px solid #808080",
                            display: "flex",
                            color: "#FFFFFF",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "12px 5px",
                          }}
                        >
                          <Box width="50%">
                            <Typography className="f-14" color="#ffffff">
                              {formatDate(item.holidayDate)}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              width: "30%",
                              display: "flex",
                              justifyContent: "left",
                            }}
                          >
                            <Typography
                              className="f-14"
                              sx={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "left",
                              }}
                            >
                              <CustomTooltip text={item.holidayName ?? ""} />
                            </Typography>
                          </Box>
                          {hasHolidaysAccess && (
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <img
                                src={EditIcon}
                                alt="Edit"
                                style={{ cursor: "pointer" }}
                                width={20}
                                height={20}
                                onClick={() => handleEditHolidayData(item)}
                              />
                              <img
                                src={DeleteIcon}
                                alt="Delete"
                                style={{
                                  marginLeft: "8px",
                                  marginRight: "8px",
                                  cursor: "pointer",
                                }}
                                width={20}
                                height={20}
                                onClick={() =>
                                  handleOpenDeleteModal(item, "holiday")
                                }
                              />
                            </Box>
                          )}
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Grid item xs={12}>
                      <Box className="noDataContainer">
                        <Typography>No Data Available</Typography>
                      </Box>
                    </Grid>
                  )}
                </Box>
              </MainCards>
            </Grid>
            {/* only show to India users */}
            {/* {userDetails?.country === "India" && ( */}
            <Grid item xs={12} sm={6} md={4}>
              {!showTabsRR ? (
                <MainCards title="RE Spotlight" minHeight="340px">
                  <Box p={1} pt={0} pb={0}>
                    <List disablePadding>
                      <ListItem
                        style={{
                          borderBottom: "1px solid #808080",
                          display: "flex",
                          alignItems: "center",
                          padding: "12px 5px",
                          cursor: "pointer",
                        }}
                        onClick={() => setShowTabsRR(true)}
                      >
                        <Box
                          style={{
                            display: "flex",
                            alignItems: "top",
                            justifyContent: "center",
                            marginRight: 12,
                          }}
                        >
                          <img
                            src={RE_Logo}
                            alt="Company Logo"
                            style={{ width: 40, height: 40 }}
                          />
                        </Box>

                        <Box width="50%">Rewards and Recognition</Box>
                      </ListItem>
                    </List>
                  </Box>
                </MainCards>
              ) : (
                <TabCards
                  title="RE Spotlight"
                  minHeight="340px"
                  onTabChange={() => {}}
                  tabLabels={[
                    "TrailBlazer",
                    "RExcellence",
                    "Cross Functional",
                    "Peer to Peer",
                  ]}
                  showNominationForm={hasRewardsRecognitionAccess}
                  onNominationClick={handleRewardAndRecognitionModalOpen}
                  ApprovalTable={hasCXOAccess}
                  onApprovalTableClick={() => {
                    navigate("/approvalPendingList");
                  }}
                >
                  {/* TrailBlazer Tab Content */}
                  <Box>
                    <SendWishesHeader
                      title="Congratulating TrailBlazers"
                      isLoading={isLoadingWishes[1] || false}
                      onSendWishes={() =>
                        handleSendWishesRandR(1, rewardsRecognitionData)
                      }
                      selectAllChecked={selectAllCheckedMap[1] || false}
                      setSelectAllChecked={(checked) =>
                        setSelectAllCheckedMap((prev) => ({
                          ...prev,
                          1: checked,
                        }))
                      }
                      onSelectAllChange={(checked) =>
                        handleSelectAllChangeRR(
                          checked,
                          1,
                          rewardsRecognitionData,
                          setRewardsRecognitionData
                        )
                      }
                    />

                    {rewardsRecognitionData?.filter((x) => x.awardId === 1)
                      ?.length > 0 ? (
                      rewardsRecognitionData
                        .filter((x) => x.awardId === 1)
                        .map((item, awardIndex) => (
                          <Box
                            key={item.id}
                            sx={{
                              borderBottom: "1px solid #808080",
                              padding: "10px",
                              marginBottom: 2,
                            }}
                          >
                            <Box display="flex" alignItems="center" gap={1}>
                              <Box sx={{ width: 50 }}>
                                <img
                                  src={medalStar}
                                  alt="logo"
                                  style={{
                                    width: 20,
                                    height: 20,
                                    paddingLeft: "4px",
                                  }}
                                />
                              </Box>
                              <CustomTooltip text={item.achievementDetails} />
                            </Box>

                            <Grid
                              container
                              spacing={1}
                              style={{ margin: "8px 0px" }}
                            >
                              {item.lstRewardAndRecognizationNomination_Members.map(
                                (user, i) => {
                                  const globalIndex = parseInt(
                                    `${awardIndex}${i}`
                                  );

                                  return (
                                    <Grid
                                      item
                                      xs={6}
                                      key={i}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                      }}
                                    >
                                      <Box display="flex" alignItems="center">
                                        <Box
                                          onMouseEnter={() =>
                                            setHoveredRandRIndex(globalIndex)
                                          }
                                          onMouseLeave={() =>
                                            setHoveredRandRIndex(null)
                                          }
                                        >
                                          {user.isChecked ||
                                          hoveredRandRIndex === globalIndex ? (
                                            <Box
                                              style={{
                                                width: 28,
                                                height: 28,
                                                borderRadius: "50%",
                                                overflow: "hidden",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                backgroundColor: "#E6E6E6",
                                              }}
                                            >
                                              <Checkbox
                                                checked={
                                                  user.isChecked || false
                                                }
                                                onChange={() => {
                                                  const updated =
                                                    rewardsRecognitionData.map(
                                                      (awardItem) => {
                                                        if (
                                                          awardItem.id ===
                                                          item.id
                                                        ) {
                                                          return {
                                                            ...awardItem,
                                                            lstRewardAndRecognizationNomination_Members:
                                                              awardItem.lstRewardAndRecognizationNomination_Members.map(
                                                                (
                                                                  member,
                                                                  index
                                                                ) =>
                                                                  index === i
                                                                    ? {
                                                                        ...member,
                                                                        isChecked:
                                                                          !member.isChecked,
                                                                      }
                                                                    : member
                                                              ),
                                                          };
                                                        }
                                                        return awardItem;
                                                      }
                                                    );

                                                  setRewardsRecognitionData(
                                                    updated
                                                  );
                                                }}
                                                sx={{
                                                  "&.Mui-checked": {
                                                    color: "#EF2E24!important",
                                                  },
                                                }}
                                              />
                                            </Box>
                                          ) : (
                                            <Box
                                              sx={{
                                                width: 28,
                                                height: 28,
                                                borderRadius: "50%",
                                                overflow: "hidden",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <img
                                                src={user.photoUrl || RE_Logo}
                                                alt={user.employeeName}
                                                style={{
                                                  width: "100%",
                                                  height: "100%",
                                                  objectFit: "cover",
                                                }}
                                              />
                                            </Box>
                                          )}
                                        </Box>

                                        <Box pl={1}>
                                          <Typography className="f-12">
                                            {user.employeeName}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </Grid>
                                  );
                                }
                              )}
                            </Grid>
                            <Box display="flex" alignItems="center" gap={1}>
                              <Box
                                sx={{
                                  width: 23,
                                  height: 23,
                                }}
                              >
                                <img
                                  src={userProfileStar}
                                  alt="Nominator"
                                  style={{
                                    paddingLeft: "2px",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                />
                              </Box>
                              <Typography className="f-12">
                                Nominated by: {item.nominatedByName}
                              </Typography>
                            </Box>
                          </Box>
                        ))
                    ) : (
                      <Grid item xs={12}>
                        <Box className="noDataContainer">
                          <Typography>No Data Available</Typography>
                        </Box>
                      </Grid>
                    )}
                  </Box>

                  {/* Re Excellence Tab Content */}
                  <Box>
                    <SendWishesHeader
                      title="Congratulating RExcellence Winners"
                      isLoading={isLoadingWishes[2] || false}
                      onSendWishes={() =>
                        handleSendWishesRandR(2, rewardsRecognitionData)
                      }
                      selectAllChecked={selectAllCheckedMap[2] || false}
                      setSelectAllChecked={(checked) =>
                        setSelectAllCheckedMap((prev) => ({
                          ...prev,
                          2: checked,
                        }))
                      }
                      onSelectAllChange={(checked) =>
                        handleSelectAllChangeRR(
                          checked,
                          2,
                          rewardsRecognitionData,
                          setRewardsRecognitionData
                        )
                      }
                    />

                    {rewardsRecognitionData?.filter((x) => x.awardId === 2)
                      ?.length > 0 ? (
                      rewardsRecognitionData
                        .filter((x) => x.awardId === 2)
                        .map((item, awardIndex) => (
                          <Box
                            key={item.id}
                            sx={{
                              borderBottom: "1px solid #808080",
                              padding: "10px",
                              marginBottom: 2,
                            }}
                          >
                            <Box display="flex" alignItems="center" gap={1}>
                              <Box sx={{ width: 50 }}>
                                <img
                                  src={medalStar}
                                  alt="logo"
                                  style={{
                                    width: 20,
                                    height: 20,
                                    paddingLeft: "2px",
                                  }}
                                />
                              </Box>
                              <CustomTooltip text={item.achievementDetails} />
                            </Box>

                            <Grid
                              container
                              spacing={1}
                              style={{ margin: "8px 0px" }}
                            >
                              {item.lstRewardAndRecognizationNomination_Members.map(
                                (user, i) => {
                                  const globalIndex = parseInt(
                                    `2${awardIndex}${i}`
                                  ); // Unique index

                                  return (
                                    <Grid
                                      item
                                      xs={6}
                                      key={i}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                      }}
                                    >
                                      <Box display="flex" alignItems="center">
                                        <Box
                                          onMouseEnter={() =>
                                            setHoveredRandRIndex(globalIndex)
                                          }
                                          onMouseLeave={() =>
                                            setHoveredRandRIndex(null)
                                          }
                                        >
                                          {user.isChecked ||
                                          hoveredRandRIndex === globalIndex ? (
                                            <Box
                                              style={{
                                                width: 28,
                                                height: 28,
                                                borderRadius: "50%",
                                                overflow: "hidden",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                backgroundColor: "#E6E6E6",
                                              }}
                                            >
                                              <Checkbox
                                                checked={
                                                  user.isChecked || false
                                                }
                                                onChange={() => {
                                                  const updated = [
                                                    ...rewardsRecognitionData,
                                                  ];
                                                  const originalIndex =
                                                    updated.findIndex(
                                                      (d) => d.id === item.id
                                                    );
                                                  if (originalIndex !== -1) {
                                                    updated[
                                                      originalIndex
                                                    ].lstRewardAndRecognizationNomination_Members[
                                                      i
                                                    ].isChecked =
                                                      !user.isChecked;
                                                    setRewardsRecognitionData(
                                                      updated
                                                    );
                                                  }
                                                }}
                                                sx={{
                                                  "&.Mui-checked": {
                                                    color: "#EF2E24!important",
                                                  },
                                                }}
                                              />
                                            </Box>
                                          ) : (
                                            <Box
                                              sx={{
                                                width: 28,
                                                height: 28,
                                                borderRadius: "50%",
                                                overflow: "hidden",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <img
                                                src={user.photoUrl || RE_Logo}
                                                alt={user.employeeName}
                                                style={{
                                                  width: "100%",
                                                  height: "100%",
                                                  objectFit: "cover",
                                                }}
                                              />
                                            </Box>
                                          )}
                                        </Box>

                                        <Box pl={1}>
                                          <Typography className="f-12">
                                            {user.employeeName}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </Grid>
                                  );
                                }
                              )}
                            </Grid>
                            <Box display="flex" alignItems="center" gap={1}>
                              <Box
                                sx={{
                                  width: 23,
                                  height: 23,
                                }}
                              >
                                <img
                                  src={userProfileStar}
                                  alt="Nominator"
                                  style={{
                                    paddingLeft: "2px",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                />
                              </Box>
                              <Typography className="f-12">
                                Nominated by: {item.nominatedByName}
                              </Typography>
                            </Box>
                          </Box>
                        ))
                    ) : (
                      <Grid item xs={12}>
                        <Box className="noDataContainer">
                          <Typography>No Data Available</Typography>
                        </Box>
                      </Grid>
                    )}
                  </Box>
                  {/* Cross Functional Tab Content */}
                  <Box>
                    <SendWishesHeader
                      title="Congratulating Cross Functional Stars"
                      isLoading={isLoadingWishes[3] || false}
                      onSendWishes={() =>
                        handleSendWishesRandR(3, rewardsRecognitionData)
                      }
                      selectAllChecked={selectAllCheckedMap[3] || false}
                      setSelectAllChecked={(checked) =>
                        setSelectAllCheckedMap((prev) => ({
                          ...prev,
                          3: checked,
                        }))
                      }
                      onSelectAllChange={(checked) =>
                        handleSelectAllChangeRR(
                          checked,
                          3,
                          rewardsRecognitionData,
                          setRewardsRecognitionData
                        )
                      }
                    />

                    {rewardsRecognitionData?.filter((x) => x.awardId === 3)
                      ?.length > 0 ? (
                      rewardsRecognitionData
                        .filter((x) => x.awardId === 3)
                        .map((item, awardIndex) => (
                          <Tooltip
                            key={item.id}
                            placement="bottom"
                            title={
                              <div
                                style={{
                                  fontStyle: "italic",
                                  fontSize: "14px",
                                  padding: "10px",
                                  backgroundColor: "#333",
                                  border: "1px solid #cccccc",
                                  borderRadius: "5px",
                                }}
                              >
                                Type: {item.crossFunctionalType}
                              </div>
                            }
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  background: "none",
                                  margin: "0px !important",
                                },
                              },
                              arrow: {
                                sx: { color: "transparent" },
                              },
                            }}
                            arrow
                          >
                            <Box
                              sx={{
                                borderBottom: "1px solid #808080",
                                padding: "10px",
                                marginBottom: 2,
                              }}
                            >
                              <Box display="flex" alignItems="center" gap={1}>
                                <Box sx={{ width: 50 }}>
                                  <img
                                    src={medalStar}
                                    alt="logo"
                                    style={{
                                      width: 20,
                                      height: 20,
                                      paddingLeft: "4px",
                                    }}
                                  />
                                </Box>
                                <CustomTooltip text={item.achievementDetails} />
                              </Box>

                              <Grid
                                container
                                spacing={1}
                                style={{ margin: "8px 0px" }}
                              >
                                {item.lstRewardAndRecognizationNomination_Members.map(
                                  (user, i) => {
                                    const globalIndex = parseInt(
                                      `3${awardIndex}${i}`
                                    );

                                    return (
                                      <Grid
                                        item
                                        xs={6}
                                        key={i}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 8,
                                        }}
                                      >
                                        <Box display="flex" alignItems="center">
                                          <Box
                                            onMouseEnter={() =>
                                              setHoveredRandRIndex(globalIndex)
                                            }
                                            onMouseLeave={() =>
                                              setHoveredRandRIndex(null)
                                            }
                                          >
                                            {user.isChecked ||
                                            hoveredRandRIndex ===
                                              globalIndex ? (
                                              <Box
                                                style={{
                                                  width: 28,
                                                  height: 28,
                                                  borderRadius: "50%",
                                                  overflow: "hidden",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  backgroundColor: "#E6E6E6",
                                                }}
                                              >
                                                <Checkbox
                                                  checked={
                                                    user.isChecked || false
                                                  }
                                                  onChange={() => {
                                                    const updated = [
                                                      ...rewardsRecognitionData,
                                                    ];
                                                    const originalIndex =
                                                      updated.findIndex(
                                                        (d) => d.id === item.id
                                                      );
                                                    if (originalIndex !== -1) {
                                                      updated[
                                                        originalIndex
                                                      ].lstRewardAndRecognizationNomination_Members[
                                                        i
                                                      ].isChecked =
                                                        !user.isChecked;
                                                      setRewardsRecognitionData(
                                                        updated
                                                      );
                                                    }
                                                  }}
                                                  sx={{
                                                    "&.Mui-checked": {
                                                      color:
                                                        "#EF2E24!important",
                                                    },
                                                  }}
                                                />
                                              </Box>
                                            ) : (
                                              <Box
                                                sx={{
                                                  width: 28,
                                                  height: 28,
                                                  borderRadius: "50%",
                                                  overflow: "hidden",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                <img
                                                  src={user.photoUrl || RE_Logo}
                                                  alt={user.employeeName}
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                />
                                              </Box>
                                            )}
                                          </Box>

                                          <Box pl={1}>
                                            <Typography className="f-12">
                                              {user.employeeName}
                                            </Typography>
                                          </Box>
                                        </Box>
                                      </Grid>
                                    );
                                  }
                                )}
                              </Grid>
                              <Box display="flex" alignItems="center" gap={1}>
                                <Box
                                  sx={{
                                    width: 23,
                                    height: 23,
                                  }}
                                >
                                  <img
                                    src={userProfileStar}
                                    alt="Nominator"
                                    style={{
                                      paddingLeft: "2px",
                                      width: "100%",
                                      height: "100%",
                                    }}
                                  />
                                </Box>
                                <Typography className="f-12">
                                  Nominated by: {item.nominatedByName}
                                </Typography>
                              </Box>
                            </Box>
                          </Tooltip>
                        ))
                    ) : (
                      <Grid item xs={12}>
                        <Box className="noDataContainer">
                          <Typography>No Data Available</Typography>
                        </Box>
                      </Grid>
                    )}
                  </Box>
                  {/* Peer to Peer Tab Content */}
                  <Box>
                    <SendWishesHeader
                      title="Congratulating Peer to Peer Heroes"
                      isLoading={isLoadingWishes[4] || false}
                      onSendWishes={() =>
                        handleSendWishesRandR(4, rewardsRecognitionData)
                      }
                      selectAllChecked={selectAllCheckedMap[4] || false}
                      setSelectAllChecked={(checked) =>
                        setSelectAllCheckedMap((prev) => ({
                          ...prev,
                          4: checked,
                        }))
                      }
                      onSelectAllChange={(checked) =>
                        handleSelectAllChangeRR(
                          checked,
                          4,
                          rewardsRecognitionData,
                          setRewardsRecognitionData
                        )
                      }
                    />

                    {rewardsRecognitionData?.filter((x) => x.awardId === 4)
                      ?.length > 0 ? (
                      rewardsRecognitionData
                        .filter((x) => x.awardId === 4)
                        .map((item, awardIndex) => (
                          <Box
                            key={item.id}
                            sx={{
                              borderBottom: "1px solid #808080",
                              padding: "10px",
                              marginBottom: 2,
                            }}
                          >
                            <Box display="flex" alignItems="center" gap={1}>
                              <Box sx={{ width: 50 }}>
                                <img
                                  src={medalStar}
                                  alt="logo"
                                  style={{
                                    width: 20,
                                    height: 20,
                                    paddingLeft: "4px",
                                  }}
                                />
                              </Box>
                              <CustomTooltip text={item.achievementDetails} />
                            </Box>

                            <Grid
                              container
                              spacing={1}
                              style={{ margin: "8px 0px" }}
                            >
                              {item.lstRewardAndRecognizationNomination_Members.map(
                                (user, i) => {
                                  const globalIndex = parseInt(
                                    `4${awardIndex}${i}`
                                  ); // unique key per tab

                                  return (
                                    <Grid
                                      item
                                      xs={6}
                                      key={i}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                      }}
                                    >
                                      <Box display="flex" alignItems="center">
                                        <Box
                                          onMouseEnter={() =>
                                            setHoveredRandRIndex(globalIndex)
                                          }
                                          onMouseLeave={() =>
                                            setHoveredRandRIndex(null)
                                          }
                                        >
                                          {user.isChecked ||
                                          hoveredRandRIndex === globalIndex ? (
                                            <Box
                                              style={{
                                                width: 28,
                                                height: 28,
                                                borderRadius: "50%",
                                                overflow: "hidden",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                backgroundColor: "#E6E6E6",
                                              }}
                                            >
                                              <Checkbox
                                                checked={
                                                  user.isChecked || false
                                                }
                                                onChange={() => {
                                                  const updated = [
                                                    ...rewardsRecognitionData,
                                                  ];
                                                  const originalIndex =
                                                    updated.findIndex(
                                                      (d) => d.id === item.id
                                                    );
                                                  if (originalIndex !== -1) {
                                                    updated[
                                                      originalIndex
                                                    ].lstRewardAndRecognizationNomination_Members[
                                                      i
                                                    ].isChecked =
                                                      !user.isChecked;
                                                    setRewardsRecognitionData(
                                                      updated
                                                    );
                                                  }
                                                }}
                                                sx={{
                                                  "&.Mui-checked": {
                                                    color: "#EF2E24!important",
                                                  },
                                                }}
                                              />
                                            </Box>
                                          ) : (
                                            <Box
                                              sx={{
                                                width: 28,
                                                height: 28,
                                                borderRadius: "50%",
                                                overflow: "hidden",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <img
                                                src={user.photoUrl || RE_Logo}
                                                alt={user.employeeName}
                                                style={{
                                                  width: "100%",
                                                  height: "100%",
                                                  objectFit: "cover",
                                                }}
                                              />
                                            </Box>
                                          )}
                                        </Box>

                                        <Box pl={1}>
                                          <Typography className="f-12">
                                            {user.employeeName}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </Grid>
                                  );
                                }
                              )}
                            </Grid>
                            <Box display="flex" alignItems="center" gap={1}>
                              <Box
                                sx={{
                                  width: 23,
                                  height: 23,
                                }}
                              >
                                <img
                                  src={userProfileStar}
                                  alt="Nominator"
                                  style={{
                                    paddingLeft: "2px",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                />
                              </Box>
                              <Typography className="f-12">
                                Nominated by: {item.nominatedByName}
                              </Typography>
                            </Box>
                          </Box>
                        ))
                    ) : (
                      <Grid item xs={12}>
                        <Box className="noDataContainer">
                          <Typography>No Data Available</Typography>
                        </Box>
                      </Grid>
                    )}
                  </Box>
                </TabCards>
              )}
            </Grid>
            {/* )} */}
            <Grid item xs={12} sm={6} md={4}>
              <TabCards
                title="REImagine"
                minHeight="340px"
                tabLabels={["Idea capturing platform"]}
                addButton={hasREImagineAccess}
                onTabChange={setREImageActiveTab}
                SPOCApprovalDashboard={hasIsSPOCAccess}
                SPOCApprovalDashboardClick={() => {
                  navigate("/implementation-pendingView");
                }}
                SPOCReimagineDashboardClick={() => {
                  navigate("/reimagineDashboard");
                }}
                submittedListingView={true}
                onSubmittedTableClick={() => {
                  navigate("/reimagineSubmittedList");
                }}
                // onButtonClick={handleREImagineModalOpen}
              >
                <Box p={0} paddingTop={0} paddingBottom={0}>
                  <List disablePadding style={{ display: "none" }}>
                    {reImagineData
                      .filter(
                        (item) =>
                          item.status == "2" ||
                          item.createdBy === userDetails.userId
                      )
                      .map((item) => {
                        return (
                          <ListItem
                            key={item.id}
                            style={{
                              borderBottom: "1px solid #808080",
                              display: "flex",
                              alignItems: "center",
                              padding: "10px 5px",
                              justifyContent: "space-between",
                              cursor: "pointer",
                            }}
                            onClick={
                              hasREImagineAccess
                                ? () => handleREImagineUpdateModal(item)
                                : () => {}
                            }
                          >
                            <Box display={"flex"} alignItems={"center"}>
                              <Box
                                style={{
                                  width: 36,
                                  height: 36,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginRight: 10,
                                }}
                              >
                                <img
                                  src={note}
                                  alt="logo"
                                  style={{
                                    width: 24,
                                    height: 24,
                                  }}
                                />
                              </Box>

                              <Typography className="f-14" color="#ffffff">
                                REImagine
                              </Typography>
                            </Box>
                          </ListItem>
                        );
                      })}
                  </List>
                  <List disablePadding>
                    <ListItem
                      style={{
                        borderBottom: "1px solid #808080",
                        display: "flex",
                        alignItems: "center",
                        padding: "10px 5px",
                        justifyContent: "space-between",
                        cursor: "pointer",
                      }}
                      onClick={handleREImagineModalOpen}
                    >
                      <Box display="flex" alignItems="center">
                        <Box
                          style={{
                            width: 36,
                            height: 36,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: 10,
                          }}
                        >
                          <img
                            src={RE_Logo}
                            alt="Company Logo"
                            style={{ width: 42, height: 42 }}
                          />
                        </Box>

                        <Typography className="f-14" color="#ffffff">
                          REImagine
                        </Typography>
                      </Box>
                    </ListItem>
                  </List>
                </Box>

                <Box p={0} paddingTop={0} paddingBottom={0}>
                  <List disablePadding>
                    {allTheHelpYouNeedTab.map((item, index) => (
                      <ListItem
                        key={index}
                        style={{
                          borderBottom: "1px solid #808080",
                          display: "flex",
                          alignItems: "center",
                          padding: "10px 5px",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box display={"flex"} alignItems={"center"}>
                          <Box
                            style={{
                              width: 36,
                              height: 36,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: 10,
                            }}
                          >
                            <img
                              src={item.icon}
                              alt="logo"
                              style={{
                                width: 24,
                                height: 24,
                              }}
                            />
                          </Box>

                          <Typography className="f-14" color="#ffffff">
                            {item.title}
                          </Typography>
                        </Box>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </TabCards>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <MainCards
                title="Learning and Development"
                minHeight="340px"
                addButton={hasLearningDevelopmentAccess}
                onButtonClick={handleLearningDevelopmentModalOpen}
              >
                <Box p={1} paddingTop={0} paddingBottom={0}>
                  {learningData.length > 0 ? (
                    <List disablePadding>
                      <>
                        {learningData.map((item, index) => (
                          <ListItem
                            key={index}
                            style={{
                              borderBottom: "1px solid #808080",
                              display: "flex",
                              alignItems: "center",
                              padding: "12px 5px",
                            }}
                          >
                            <a
                              href={item.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                flex: 1,
                                textDecoration: "none",
                                color: "inherit",
                              }}
                            >
                              <Box
                                style={{
                                  width: 36,
                                  height: 36,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginRight: 10,
                                }}
                              >
                                <img
                                  src={item.logoUrl ? item.logoUrl : RE_Logo}
                                  alt={item.title}
                                  style={{
                                    width: 32,
                                    height: 32,
                                    objectFit: "cover",
                                  }}
                                />
                              </Box>
                              <Typography
                                className="f-14"
                                sx={{
                                  width: "75%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <CustomTooltip text={item.title} />
                              </Typography>
                            </a>

                            {hasLearningDevelopmentAccess && (
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                                onClick={(e) => e.stopPropagation()} // extra safety
                              >
                                <img
                                  src={EditIcon}
                                  alt="Edit"
                                  style={{ cursor: "pointer" }}
                                  width={20}
                                  height={20}
                                  onClick={() =>
                                    handleEditLearningDevelopmentData(item)
                                  }
                                />
                                <img
                                  src={DeleteIcon}
                                  alt="Delete"
                                  style={{
                                    marginLeft: "8px",
                                    cursor: "pointer",
                                  }}
                                  width={20}
                                  height={20}
                                  onClick={() =>
                                    handleOpenDeleteModal(
                                      item,
                                      "learningDevelopment"
                                    )
                                  }
                                />
                              </Box>
                            )}
                          </ListItem>
                        ))}
                      </>
                    </List>
                  ) : (
                    <Grid item xs={12}>
                      <Box className="noDataContainer">
                        <Typography>No Data Available</Typography>
                      </Box>
                    </Grid>
                  )}
                </Box>
              </MainCards>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <MainCards
                title="Internal Job Posting"
                minHeight="350px"
                addButton={hasInternalJobPostingAccess}
                onButtonClick={handleInternalJobOpen}
              >
                <Box p={1} paddingTop={0} paddingBottom={0}>
                  {jobPostings.length > 0 ? (
                    <List disablePadding>
                      {jobPostings.map((item, index) => (
                        <a
                          key={index}
                          href={item.driveLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          <ListItem
                            style={{
                              borderBottom: "1px solid #808080",
                              display: "flex",
                              alignItems: "center",
                              padding: "12px 5px",
                              cursor: "pointer",
                            }}
                          >
                            <Box
                              style={{
                                display: "flex",
                                alignItems: "top",
                                justifyContent: "center",
                                marginRight: 12,
                              }}
                            >
                              <img
                                src={RE_Logo}
                                alt="Company Logo"
                                style={{ width: 40, height: 40 }}
                              />
                            </Box>

                            <Box flex={1}>
                              <Typography
                                className="f-14"
                                sx={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <CustomTooltip
                                  text={item.jobOpeningTitle || ""}
                                />
                              </Typography>

                              <Box sx={{ display: "flex" }}>
                                <Typography
                                  className="f-11"
                                  style={{ color: "#CCCCCC" }}
                                >
                                  {item.jobDesignation}
                                </Typography>
                                <Typography
                                  sx={{
                                    borderLeft: "1.3px solid #808080",
                                    mx: 0.7,
                                    my: "3px",
                                  }}
                                ></Typography>
                                <Typography
                                  className="f-11"
                                  style={{ color: "#CCCCCC" }}
                                >
                                  {item.jobOpeningLocation}
                                </Typography>
                                <Typography
                                  sx={{
                                    borderLeft: "1.3px solid #808080",
                                    mx: 0.7,
                                    my: "3px",
                                  }}
                                ></Typography>
                                <Typography
                                  className="f-11"
                                  style={{
                                    color: "#CCCCCC",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    maxWidth: "150px",
                                  }}
                                >
                                  {item.emailId}
                                </Typography>
                              </Box>
                              <Typography
                                className="f-11"
                                style={{
                                  color: "#CCCCCC",
                                  fontWeight: "bold",
                                  marginTop: "5px",
                                }}
                              >
                                Open till:
                                {" " +
                                  dayjs(item.expirationDate).format(
                                    "DD-MMM-YYYY"
                                  )}
                              </Typography>
                            </Box>
                            {hasInternalJobPostingAccess && (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  pointerEvents: "auto",
                                }}
                              >
                                <img
                                  src={EditIcon}
                                  alt="Edit"
                                  style={{ cursor: "pointer" }}
                                  width={20}
                                  height={20}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleEditInternalJobData(item);
                                  }}
                                />
                                <img
                                  src={DeleteIcon}
                                  alt="Delete"
                                  style={{
                                    marginLeft: "8px",
                                    cursor: "pointer",
                                  }}
                                  width={20}
                                  height={20}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleOpenDeleteModal(
                                      item,
                                      "internalJobPosting"
                                    );
                                  }}
                                />
                              </Box>
                            )}
                          </ListItem>
                        </a>
                      ))}
                    </List>
                  ) : (
                    <Grid item xs={12}>
                      <Box className="noDataContainer">
                        <Typography>No Data Available</Typography>
                      </Box>
                    </Grid>
                  )}
                </Box>{" "}
              </MainCards>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <MainCards
                title="iRefer - Employee Referral Program"
                minHeight="350px"
                addButton={hasEmployeeReferralProgramAccess}
                onButtonClick={handleIReferOpen}
              >
                <Box p={1} paddingTop={0} paddingBottom={0}>
                  <List disablePadding>
                    {employeeIReferralData.length > 0 ? (
                      <List disablePadding>
                        {employeeIReferralData.map((item, index) => (
                          <a
                            key={index}
                            href={item.driveLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            <ListItem
                              style={{
                                borderBottom: "1px solid #808080",
                                display: "flex",
                                alignItems: "center",
                                padding: "12px 5px",
                                cursor: "pointer",
                              }}
                            >
                              <Box
                                style={{
                                  display: "flex",
                                  alignItems: "top",
                                  justifyContent: "center",
                                  marginRight: 12,
                                }}
                              >
                                <img
                                  src={RE_Logo}
                                  alt="Company Logo"
                                  style={{ width: 40, height: 40 }}
                                />
                              </Box>

                              <Box flex={1}>
                                <Typography
                                  className="f-14"
                                  sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <CustomTooltip
                                    text={item.jobOpeningTitle || ""}
                                  />
                                </Typography>

                                <Box sx={{ display: "flex" }}>
                                  <Typography
                                    className="f-11"
                                    style={{ color: "#CCCCCC" }}
                                  >
                                    {item.jobDesignation}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      borderLeft: "1.3px solid #808080",
                                      mx: 0.7,
                                      my: "3px",
                                    }}
                                  ></Typography>
                                  <Typography
                                    className="f-11"
                                    style={{ color: "#CCCCCC" }}
                                  >
                                    {item.jobOpeningLocation}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      borderLeft: "1.3px solid #808080",
                                      mx: 0.7,
                                      my: "3px",
                                    }}
                                  ></Typography>
                                  <Typography
                                    className="f-11"
                                    style={{
                                      color: "#CCCCCC",
                                      overflow: "hidden",
                                      whiteSpace: "nowrap",
                                      textOverflow: "ellipsis",
                                      maxWidth: "150px",
                                    }}
                                  >
                                    {item.emailId}
                                  </Typography>
                                </Box>
                                <Typography
                                  className="f-11"
                                  style={{
                                    color: "#CCCCCC",
                                    fontWeight: "bold",
                                    marginTop: "5px",
                                  }}
                                >
                                  Open till:
                                  {" " +
                                    dayjs(item.expirationDate).format(
                                      "DD-MMM-YYYY"
                                    )}
                                </Typography>
                              </Box>
                              {hasEmployeeReferralProgramAccess && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    pointerEvents: "auto",
                                  }}
                                >
                                  <img
                                    src={EditIcon}
                                    alt="Edit"
                                    style={{ cursor: "pointer" }}
                                    width={20}
                                    height={20}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleEditEmployeeIReferData(item);
                                    }}
                                  />
                                  <img
                                    src={DeleteIcon}
                                    alt="Delete"
                                    style={{
                                      marginLeft: "8px",
                                      cursor: "pointer",
                                    }}
                                    width={20}
                                    height={20}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleOpenDeleteModal(item, "iReferral");
                                    }}
                                  />
                                </Box>
                              )}
                            </ListItem>
                          </a>
                        ))}
                      </List>
                    ) : (
                      <Grid item xs={12}>
                        <Box className="noDataContainer">
                          <Typography>No Data Available</Typography>
                        </Box>
                      </Grid>
                    )}
                  </List>
                </Box>
              </MainCards>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <MainCards
                title="New Joiners"
                minHeight="350px"
                dropdownOptions={["Today", "Last 7 days", "Last 1 Month"]}
                selectedValue={selectedFilter}
                onDropdownChange={(value) => {
                  setSelectedFilter(value);
                  fetchNewJoiners(value);
                }}
              >
                <Box p={1}>
                  <Box
                    style={{
                      padding: "10px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderRadius: "5px",
                      backgroundColor: "#393939",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "12px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={celebration}
                        alt="logo"
                        style={{
                          paddingRight: "7px",
                          width: "16px",
                          height: "16px",
                        }}
                      />
                      Welcoming our colleagues.
                    </Typography>
                    <Typography
                      style={{
                        cursor: !isNewJoinerLoader ? "pointer" : "not-allowed",
                        color: !isNewJoinerLoader ? "#ffffff" : "#888888",
                        opacity: !isNewJoinerLoader ? 1 : 0.6,
                        fontSize: "11px",
                        fontWeight: "600",
                      }}
                      onClick={() => {
                        if (!isNewJoinerLoader) {
                          handleUserSendWishes("New Joiners");
                        }
                      }}
                    >
                      SEND WISHES
                    </Typography>
                  </Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectAllNewJoinersChecked}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setSelectAllNewJoinersChecked(checked);

                          setNewJoiners((prev) =>
                            prev.map((item) =>
                              !item.isWishSent
                                ? {
                                    ...item,
                                    isChecked: checked,
                                  }
                                : item
                            )
                          );
                        }}
                        sx={{
                          color: "#ffffff",
                          borderColor: "#ffffff",
                          "&.Mui-checked": {
                            color: "#EF2E24!important",
                            borderColor: "#EF2E24",
                          },
                          "& .css-1c760o4-MuiButtonBase-root-MuiCheckbox-root .MuiSvgIcon-root":
                            {
                              color: "#ffffff",
                            },
                        }}
                      />
                    }
                    label="Select All"
                    sx={{
                      mt: 1,
                      mx: 1,
                      "& .MuiTypography-root": {
                        fontSize: "14px",
                        cursor: "pointer",
                      },
                    }}
                  />

                  <Grid container>
                    {newJoiners.length > 0 ? (
                      newJoiners.map((data, i) => {
                        return (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={6}
                            key={i}
                            style={{ padding: "10px 10px" }}
                          >
                            <Box display="flex" alignItems="center">
                              <Box
                                onMouseEnter={() => setHoveredNewJoinerIndex(i)}
                                onMouseLeave={() =>
                                  setHoveredNewJoinerIndex(null)
                                }
                              >
                                {data.isChecked ||
                                hoveredNewJoinerIndex === i ? (
                                  <Box
                                    style={{
                                      width: 36,
                                      height: 36,
                                      borderRadius: "50%",
                                      overflow: "hidden",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      backgroundColor: "#E6E6E6",
                                    }}
                                  >
                                    <Checkbox
                                      checked={data.isChecked}
                                      onChange={() => {
                                        if (data.isWishSent) {
                                          showToast(
                                            "You have already wished",
                                            "error"
                                          );
                                          return;
                                        }

                                        setNewJoiners((prev) => {
                                          const newList = prev.map((joiner) =>
                                            joiner.userId === data.userId
                                              ? {
                                                  ...joiner,
                                                  isChecked: !joiner.isChecked,
                                                }
                                              : joiner
                                          );
                                          const allSelected = newList
                                            .filter((el) => !el.isWishSent)
                                            .every((el) => el.isChecked);

                                          setSelectAllNewJoinersChecked(
                                            allSelected
                                          );

                                          return newList;
                                        });
                                      }}
                                      sx={{
                                        "&.Mui-checked": {
                                          color: "#EF2E24!important",
                                          borderColor: "#EF2E24",
                                        },
                                        "& .css-1c760o4-MuiButtonBase-root-MuiCheckbox-root .MuiSvgIcon-root":
                                          {
                                            color: "#808080",
                                          },
                                      }}
                                    />
                                  </Box>
                                ) : (
                                  <Box
                                    sx={{
                                      width: 36,
                                      height: 36,
                                      borderRadius: "50%",
                                      overflow: "hidden",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <img
                                      src={
                                        data.imageUrl ? data.imageUrl : RE_Logo
                                      }
                                      alt="Img"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </Box>
                                )}
                              </Box>

                              <Box
                                pl={1}
                                flexGrow={1}
                                sx={{ overflow: "hidden", width: "130px" }}
                              >
                                <Typography
                                  className="f-14"
                                  sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <CustomTooltip text={data.name ?? ""} />
                                </Typography>
                                <Typography
                                  className="f-14"
                                  sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <CustomTooltip
                                    fontSize="11px"
                                    text={`${data.designation ?? ""} ${
                                      data.department ?? ""
                                    }`}
                                  />
                                </Typography>
                              </Box>
                            </Box>
                          </Grid>
                        );
                      })
                    ) : (
                      <Grid item xs={12}>
                        <Box className="noDataContainer">
                          <Typography>No Data Available</Typography>
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </MainCards>
            </Grid>
            {/* checkbox UI ------------------------------ */}
            <Grid item xs={12} sm={6} md={4}>
              <MediaCardSection
                title="Open Road (DEI)"
                addButton={hasOpenRoadAccess}
                onButtonClick={handleOpenRoadModalOpen}
                dropdownOptions={openRoadTypesList}
                selectedValue={selectedOpenRoadFilter}
                onDropdownChange={(value) => {
                  const filteredData = fullopenRoadData.filter(
                    (item) => item.type.toLowerCase() === value.toLowerCase()
                  );
                  setopenRoadData(
                    value === "All" ? fullopenRoadData : filteredData
                  );
                  setSelectedOpenRoadFilter(value);
                }}
              >
                <div>
                  <Grid container spacing={2}>
                    {openRoadData.length > 0 ? (
                      <>
                        {openRoadData.map((item, index) => {
                          const isYouTubeValid =
                            item.isYouTubeLink &&
                            item.youtubeUrl?.match(
                              /^https:\/\/(www\.youtube\.com|youtu\.be)\//
                            );
                          const hasFilePath =
                            item.filePath && item.filePath !== "";

                          return (
                            <Grid item xs={12} sm={6} md={6} key={index}>
                              <Card
                                elevation={1}
                                square
                                sx={{
                                  overflow: "hidden",
                                  color: "#ffffff",
                                  borderRadius: "3px",
                                  boxShadow: "none",
                                  position: "relative",
                                  backgroundColor: "#393939",
                                }}
                              >
                                {(isYouTubeValid || hasFilePath) && (
                                  <Avatar
                                    onClick={() =>
                                      handleCheckLeadershipVideo(
                                        item.isYouTubeLink,
                                        item.youtubeUrl,
                                        item.filePath,
                                        item.title
                                      )
                                    }
                                    sx={{
                                      width: 40,
                                      height: 30,
                                      bgcolor: "rgba(0,0,0,0.8)",
                                      color: "white",
                                      position: "absolute",
                                      borderRadius: "25%",
                                      cursor: "pointer",
                                      top: "41%",
                                      left: "50%",
                                      transform: "translate(-50%, -50%)",
                                      transition: "background-color 0.3s ease",
                                      "&:hover": {
                                        bgcolor: "#FF0000",
                                      },
                                    }}
                                  >
                                    ▶
                                  </Avatar>
                                )}

                                <Box
                                  sx={{
                                    padding: "8px 8px 0px 8px",
                                    overflow: "hidden",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    if (!(isYouTubeValid || hasFilePath)) {
                                      window.open(item.youtubeUrl, "_blank");
                                    }
                                  }}
                                >
                                  <img
                                    src={item.thumbNailPath || ""}
                                    alt={item.title}
                                    style={{
                                      width: "100%",
                                      height: "87px",
                                      objectFit: "cover",
                                      backgroundColor: "#393939",
                                      display: "block",
                                    }}
                                  />
                                </Box>

                                {item.type === "video" && (
                                  <Avatar
                                    sx={{
                                      width: 40,
                                      height: 30,
                                      bgcolor: "rgba(0,0,0,0.8)",
                                      color: "white",
                                      position: "absolute",
                                      borderRadius: "25%",
                                      top: "41%",
                                      left: "50%",
                                      transform: "translate(-50%, -50%)",
                                      transition: "background-color 0.3s ease",
                                      "&:hover": {
                                        bgcolor: "#FF0000",
                                      },
                                    }}
                                  >
                                    ▶
                                  </Avatar>
                                )}

                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      padding: "8px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      width: "65%",
                                    }}
                                  >
                                    <Typography
                                      fontWeight="400"
                                      sx={{
                                        maxWidth: "100%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <CustomTooltip
                                        fontSize="12px"
                                        text={item.title}
                                      />
                                    </Typography>
                                  </Box>
                                  {hasOpenRoadAccess && (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <img
                                        src={EditIcon}
                                        alt="Edit"
                                        style={{ cursor: "pointer" }}
                                        width={20}
                                        height={20}
                                        onClick={() =>
                                          handleGetEditOpenRoadData(item)
                                        }
                                      />
                                      <img
                                        src={DeleteIcon}
                                        alt="Delete"
                                        style={{
                                          marginLeft: "8px",
                                          marginRight: "8px",
                                          cursor: "pointer",
                                        }}
                                        width={20}
                                        height={20}
                                        onClick={() =>
                                          handleOpenDeleteModal(
                                            item,
                                            "OpenRoad"
                                          )
                                        }
                                      />
                                    </Box>
                                  )}
                                </Box>
                              </Card>
                            </Grid>
                          );
                        })}
                      </>
                    ) : (
                      <Grid item xs={12}>
                        <Box className="noDataContainer">
                          <Typography>No Data Available</Typography>
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </div>
              </MediaCardSection>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <MediaCardSection
                title="Our Social Mission"
                addButton={hasOurSocialMissionAccess}
                onButtonClick={handleSocialMissionOpen}
                dropdownOptions={socialMissionTypesList}
                selectedValue={selectedSocialMissionFilter}
                onDropdownChange={(value) => {
                  const filteredData = fullSocialMissionData.filter(
                    (item) => item.type.toLowerCase() === value.toLowerCase()
                  );
                  setSocialMissionData(
                    value === "All" ? fullSocialMissionData : filteredData
                  );
                  setSelectedSocialMissionFilter(value);
                }}
              >
                <div>
                  <Grid container spacing={2}>
                    {socialMissionData.length > 0 ? (
                      <>
                        {socialMissionData.map((item, index) => {
                          const isYouTubeValid =
                            item.isYouTubeLink &&
                            item.youtubeUrl?.match(
                              /^https:\/\/(www\.youtube\.com|youtu\.be)\//
                            );
                          const hasFilePath =
                            item.filePath && item.filePath !== "";

                          return (
                            <Grid item xs={12} sm={6} md={6} key={index}>
                              <Card
                                elevation={1}
                                square
                                sx={{
                                  overflow: "hidden",
                                  color: "#ffffff",
                                  borderRadius: "3px",
                                  boxShadow: "none",
                                  position: "relative",
                                  backgroundColor: "#393939",
                                }}
                              >
                                {(isYouTubeValid || hasFilePath) && (
                                  <Avatar
                                    onClick={() =>
                                      handleCheckLeadershipVideo(
                                        item.isYouTubeLink,
                                        item.youtubeUrl,
                                        item.filePath,
                                        item.title
                                      )
                                    }
                                    sx={{
                                      width: 40,
                                      height: 30,
                                      bgcolor: "rgba(0,0,0,0.8)",
                                      color: "white",
                                      position: "absolute",
                                      borderRadius: "25%",
                                      cursor: "pointer",
                                      top: "41%",
                                      left: "50%",
                                      transform: "translate(-50%, -50%)",
                                      transition: "background-color 0.3s ease",
                                      "&:hover": {
                                        bgcolor: "#FF0000",
                                      },
                                    }}
                                  >
                                    ▶
                                  </Avatar>
                                )}

                                <Box
                                  sx={{
                                    padding: "8px 8px 0px 8px",
                                    overflow: "hidden",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    if (!(isYouTubeValid || hasFilePath)) {
                                      window.open(item.youtubeUrl, "_blank");
                                    }
                                  }}
                                >
                                  <img
                                    src={item.thumbNailPath || ""}
                                    alt={item.title}
                                    style={{
                                      width: "100%",
                                      height: "87px",
                                      objectFit: "cover",
                                      backgroundColor: "#393939",
                                      display: "block",
                                    }}
                                  />
                                </Box>

                                {item.type === "video" && (
                                  <Avatar
                                    sx={{
                                      width: 40,
                                      height: 30,
                                      bgcolor: "rgba(0,0,0,0.8)",
                                      color: "white",
                                      position: "absolute",
                                      borderRadius: "25%",
                                      top: "41%",
                                      left: "50%",
                                      transform: "translate(-50%, -50%)",
                                      transition: "background-color 0.3s ease",
                                      "&:hover": {
                                        bgcolor: "#FF0000",
                                      },
                                    }}
                                  >
                                    ▶
                                  </Avatar>
                                )}

                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      padding: "8px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      width: "65%",
                                    }}
                                  >
                                    <Typography
                                      fontWeight="400"
                                      sx={{
                                        maxWidth: "100%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <CustomTooltip
                                        fontSize="12px"
                                        text={item.title}
                                      />
                                    </Typography>
                                  </Box>
                                  {hasOurSocialMissionAccess && (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <img
                                        src={EditIcon}
                                        alt="Edit"
                                        style={{ cursor: "pointer" }}
                                        width={20}
                                        height={20}
                                        onClick={() =>
                                          handleGetEditSocialMissionData(item)
                                        }
                                      />
                                      <img
                                        src={DeleteIcon}
                                        alt="Delete"
                                        style={{
                                          marginLeft: "8px",
                                          marginRight: "8px",
                                          cursor: "pointer",
                                        }}
                                        width={20}
                                        height={20}
                                        onClick={() =>
                                          handleOpenDeleteModal(
                                            item,
                                            "socialMission"
                                          )
                                        }
                                      />
                                    </Box>
                                  )}
                                </Box>
                              </Card>
                            </Grid>
                          );
                        })}
                      </>
                    ) : (
                      <Grid item xs={12}>
                        <Box className="noDataContainer">
                          <Typography>No Data Available</Typography>
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </div>
              </MediaCardSection>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <MainCards
                title="Birthdays and Work Anniversaries"
                minHeight="340px"
                dropdownOptions={["Today", "Last 7 days", "Upcoming 7 days"]}
                selectedValue={selectedBirthAnniversaryFilter}
                onDropdownChange={(value) => {
                  setSelectedBirthAnniversaryFilter(value);
                  fetchBirthdayWorkAnniversaries(value);
                }}
              >
                <Box p={1}>
                  {/* Header */}
                  <Box
                    style={{
                      padding: "10px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderRadius: "5px",
                      backgroundColor: "#393939",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "12px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={celebration}
                        alt="logo"
                        style={{
                          paddingRight: "7px",
                          width: "15px",
                          height: "16px",
                        }}
                      />
                      Wish your colleagues on their special days.
                    </Typography>
                    <Typography
                      style={{
                        cursor: !isBirthdayLoader ? "pointer" : "not-allowed",
                        color: !isBirthdayLoader ? "#ffffff" : "#888888",
                        opacity: !isBirthdayLoader ? 1 : 0.6,
                        fontSize: "11px",
                        fontWeight: "600",
                      }}
                      onClick={() => {
                        if (!isBirthdayLoader) {
                          handleUserSendWishes("Birthday");
                        }
                      }}
                    >
                      SEND WISHES
                    </Typography>
                  </Box>

                  {/* Checkboxes */}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectAllCheckedBirthday}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setSelectAllCheckedBirthday(checked);

                            setBirthdayWorkAnniversaries((prev) =>
                              prev.map((item) =>
                                item.isBirthDay && !item.isWishSent
                                  ? {
                                      ...item,
                                      isChecked: checked,
                                    }
                                  : item
                              )
                            );
                          }}
                          sx={{
                            color: "#ffffff",
                            borderColor: "#ffffff",
                            "&.Mui-checked": {
                              color: "#EF2E24!important",
                              borderColor: "#EF2E24",
                            },
                            "& .css-1c760o4-MuiButtonBase-root-MuiCheckbox-root .MuiSvgIcon-root":
                              {
                                color: "#ffffff",
                              },
                          }}
                        />
                      }
                      label="Select All Birthdays"
                      sx={{
                        mt: 1,
                        mx: 1,
                        width: "46%",
                        "& .MuiTypography-root": {
                          fontSize: "14px",
                          cursor: "pointer",
                        },
                      }}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isYesterdayChecked}
                          onChange={handleYesterdayCheckboxClick}
                          sx={{
                            color: "#ffffff",
                            borderColor: "#ffffff",
                            "&.Mui-checked": {
                              color: "#EF2E24!important",
                              borderColor: "#EF2E24",
                            },
                            "& .css-1c760o4-MuiButtonBase-root-MuiCheckbox-root .MuiSvgIcon-root":
                              {
                                color: "#ffffff",
                              },
                          }}
                        />
                      }
                      label="Yesterday"
                      sx={{
                        mt: 1,
                        mx: 1,
                        mr: 4,
                        "& .MuiTypography-root": {
                          fontSize: "14px",
                          cursor: "pointer",
                        },
                      }}
                    />
                  </Box>

                  {/* Birthdays List */}
                  <Grid container>
                    {birthdayWorkAnniversaries
                      .filter((item) => item.isBirthDay)
                      .map((item, i) => (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={6}
                          key={i}
                          style={{ padding: "10px 10px" }}
                        >
                          <Box display="flex" alignItems="center">
                            <Box
                              onMouseEnter={() => setHoveredBirthAnnyIndex(i)}
                              onMouseLeave={() =>
                                setHoveredBirthAnnyIndex(null)
                              }
                            >
                              {item.isChecked || hoveredBirthAnnyIndex === i ? (
                                <Box
                                  style={{
                                    width: 36,
                                    height: 36,
                                    borderRadius: "50%",
                                    overflow: "hidden",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#E6E6E6",
                                  }}
                                >
                                  <Checkbox
                                    checked={item.isChecked}
                                    onChange={() => {
                                      if (item.isWishSent) {
                                        showToast(
                                          "You have already wished",
                                          "error"
                                        );
                                        return;
                                      }

                                      setBirthdayWorkAnniversaries((prev) =>
                                        prev.map((anniversary, index) =>
                                          index === i
                                            ? {
                                                ...anniversary,
                                                isChecked:
                                                  !anniversary.isChecked,
                                              }
                                            : anniversary
                                        )
                                      );
                                    }}
                                    sx={{
                                      "&.Mui-checked": {
                                        color: "#EF2E24!important",
                                        borderColor: "#EF2E24",
                                      },
                                      "& .css-1c760o4-MuiButtonBase-root-MuiCheckbox-root .MuiSvgIcon-root":
                                        {
                                          color: "#808080",
                                        },
                                    }}
                                  />
                                </Box>
                              ) : (
                                <Box
                                  sx={{
                                    width: 36,
                                    height: 36,
                                    borderRadius: "50%",
                                    overflow: "hidden",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={
                                      item.imageUrl ? item.imageUrl : RE_Logo
                                    }
                                    alt="Img"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                </Box>
                              )}
                            </Box>

                            <Box
                              pl={1}
                              flexGrow={1}
                              sx={{ overflow: "hidden", width: "130px" }}
                            >
                              <Typography
                                className="f-14"
                                sx={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <CustomTooltip text={item.employeeName ?? ""} />
                              </Typography>
                              <Typography
                                className="f-14"
                                sx={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <CustomTooltip
                                  fontSize="11px"
                                  text={item.eventType ?? ""}
                                />
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                      ))}
                  </Grid>

                  {/* Work Anniversaries List */}
                  <Grid container>
                    <Grid item xs={12} md={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectAllCheckedAnniversary}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setSelectAllCheckedAnniversary(checked);

                              setBirthdayWorkAnniversaries((prev) =>
                                prev.map((item) =>
                                  item.isAnniversary && !item.isWishSent
                                    ? {
                                        ...item,
                                        isChecked: checked,
                                      }
                                    : item
                                )
                              );
                            }}
                            sx={{
                              color: "#ffffff",
                              borderColor: "#ffffff",
                              "&.Mui-checked": {
                                color: "#EF2E24!important",
                                borderColor: "#EF2E24",
                              },
                              "& .css-1c760o4-MuiButtonBase-root-MuiCheckbox-root .MuiSvgIcon-root":
                                {
                                  color: "#ffffff",
                                },
                            }}
                          />
                        }
                        label="Select All Work Anniversaries"
                        sx={{
                          mt: 1,
                          mx: 1,
                          width: "100%",
                          "& .MuiTypography-root": {
                            fontSize: "14px",
                            cursor: "pointer",
                          },
                        }}
                      />
                    </Grid>

                    {birthdayWorkAnniversaries
                      .filter((item) => item.isAnniversary)
                      .map((item, i) => (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={6}
                          key={i}
                          style={{ padding: "10px 10px" }}
                        >
                          <Box display="flex" alignItems="center">
                            <Box
                              onMouseEnter={() => setHoveredBirthAnnyIndex(i)}
                              onMouseLeave={() =>
                                setHoveredBirthAnnyIndex(null)
                              }
                            >
                              {item.isChecked || hoveredBirthAnnyIndex === i ? (
                                <Box
                                  style={{
                                    width: 36,
                                    height: 36,
                                    borderRadius: "50%",
                                    overflow: "hidden",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#E6E6E6",
                                  }}
                                >
                                  <Checkbox
                                    checked={item.isChecked}
                                    onChange={() => {
                                      if (item.isWishSent) {
                                        showToast(
                                          "You have already wished",
                                          "error"
                                        );
                                        return;
                                      }

                                      setBirthdayWorkAnniversaries((prev) => {
                                        const newList = prev.map(
                                          (anniversary) =>
                                            anniversary.userId === item.userId
                                              ? {
                                                  ...anniversary,
                                                  isChecked:
                                                    !anniversary.isChecked,
                                                }
                                              : anniversary
                                        );

                                        const allSelected = newList
                                          .filter(
                                            (el) =>
                                              el.isAnniversary && !el.isWishSent
                                          )
                                          .every((el) => el.isChecked);

                                        setSelectAllCheckedAnniversary(
                                          allSelected
                                        );

                                        return newList;
                                      });
                                    }}
                                    sx={{
                                      "&.Mui-checked": {
                                        color: "#EF2E24!important",
                                        borderColor: "#EF2E24",
                                      },
                                      "& .css-1c760o4-MuiButtonBase-root-MuiCheckbox-root .MuiSvgIcon-root":
                                        {
                                          color: "#808080",
                                        },
                                    }}
                                  />
                                </Box>
                              ) : (
                                <Box
                                  sx={{
                                    width: 36,
                                    height: 36,
                                    borderRadius: "50%",
                                    overflow: "hidden",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={
                                      item.imageUrl ? item.imageUrl : RE_Logo
                                    }
                                    alt="Img"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                </Box>
                              )}
                            </Box>

                            <Box
                              pl={1}
                              flexGrow={1}
                              sx={{ overflow: "hidden", width: "130px" }}
                            >
                              <Typography
                                className="f-14"
                                sx={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <CustomTooltip text={item.employeeName ?? ""} />
                              </Typography>
                              <Typography
                                className="f-14"
                                sx={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <CustomTooltip
                                  fontSize="11px"
                                  text={item.eventType ?? ""}
                                />
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                      ))}
                  </Grid>
                </Box>
              </MainCards>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <MainCards
                title="Performance Management"
                minHeight="340px"
                addButton={hasPerformanceManagementAccess}
                onButtonClick={handlePerformanceModalOpen}
              >
                <Box p={1}>
                  <List disablePadding>
                    {performanceManagementList.length > 0 ? (
                      performanceManagementList.map((item) => (
                        <ListItem
                          key={item.id}
                          style={{
                            borderBottom: "1px solid #808080",
                            padding: "12px 8px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {" "}
                          <a
                            href={item.driveLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              textDecoration: "none",
                              width: "85%",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginRight: "5%",
                              }}
                            >
                              <img
                                src={item.logoUrl}
                                alt="img"
                                style={{
                                  width: 32,
                                  height: 32,
                                  objectFit: "cover",
                                }}
                              />
                            </Box>
                            <Box sx={{ overflow: "hidden", flex: 1 }}>
                              <Typography
                                className="f-14"
                                sx={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <CustomTooltip
                                  fontWeight={500}
                                  text={item.title ?? ""}
                                />
                              </Typography>
                              <Typography
                                style={{
                                  fontSize: "12px",
                                  color: "#E6E6E6",
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {item.year}
                              </Typography>
                            </Box>{" "}
                          </a>
                          {hasPerformanceManagementAccess && (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                width: "106px",
                                justifyContent: "flex-end",
                              }}
                            >
                              <img
                                src={EditIcon}
                                alt="Edit"
                                style={{ cursor: "pointer", marginLeft: "8px" }}
                                width={20}
                                height={20}
                                onClick={() =>
                                  handlePerformanceUpdateData(item)
                                }
                              />
                              <img
                                src={DeleteIcon}
                                alt="Delete"
                                style={{ marginLeft: "8px", cursor: "pointer" }}
                                width={20}
                                height={20}
                                onClick={() =>
                                  handleOpenDeleteModal(
                                    item,
                                    "performanceManagement"
                                  )
                                }
                              />
                            </Box>
                          )}
                        </ListItem>
                      ))
                    ) : (
                      <Grid item xs={12}>
                        <Box className="noDataContainer">
                          <Typography>No Data Available</Typography>
                        </Box>
                      </Grid>
                    )}
                  </List>
                </Box>
              </MainCards>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <MainCards
                title="NPI"
                minHeight="340px"
                addButton={hasNPIAccess}
                onButtonClick={handleNPIModalOpen}
              >
                <Box p={1} paddingTop={0} paddingBottom={0}>
                  {NPIData.length > 0 ? (
                    <List disablePadding>
                      {NPIData.map((item, index) => (
                        <ListItemButton
                          key={index}
                          component="a"
                          target="blank"
                          href={item.spaceLink}
                          sx={{
                            borderBottom: "1px solid #808080",
                            padding: "12px 10px",
                            justifyContent: "space-between",
                            display: "flex",
                            gap: 1.5,
                            textDecoration: "none",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              width: "80%",
                            }}
                          >
                            <Box
                              sx={{
                                width: 36,
                                height: 36,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                                marginRight: 2,
                              }}
                            >
                              <img
                                src={item.logoUrl}
                                alt="img"
                                style={{
                                  width: 32,
                                  height: 32,
                                  objectFit: "cover",
                                }}
                              />
                            </Box>

                            <Box>
                              <Typography
                                className="f-14"
                                sx={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <CustomTooltip
                                  fontWeight={500}
                                  text={item.title ?? ""}
                                />
                              </Typography>
                              <Typography
                                className="f-14"
                                sx={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <CustomTooltip
                                  fontSize="12px"
                                  text={item.description ?? ""}
                                />
                              </Typography>
                            </Box>
                          </Box>
                          {hasNPIAccess && (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",

                                justifyContent: "end",
                              }}
                            >
                              <img
                                src={EditIcon}
                                alt="Edit"
                                style={{ cursor: "pointer", marginLeft: "8px" }}
                                width={20}
                                height={20}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleNPIUpdateData(item);
                                }}
                              />
                              <img
                                src={DeleteIcon}
                                alt="Delete"
                                style={{ marginLeft: "8px", cursor: "pointer" }}
                                width={20}
                                height={20}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleOpenDeleteModal(item, "NPI");
                                }}
                              />
                            </Box>
                          )}
                        </ListItemButton>
                      ))}
                    </List>
                  ) : (
                    <Grid item xs={12}>
                      <Box className="noDataContainer">
                        <Typography>No Data Available</Typography>
                      </Box>
                    </Grid>
                  )}
                </Box>
              </MainCards>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <MediaCardSection
                title="Events"
                addButton={hasEventsAccess}
                onButtonClick={handleVideoVaultModalOpen}
                dropdownOptions={eventsTypesList}
                selectedValue={selectedEventsFilter}
                onDropdownChange={(value) => {
                  const filteredData = fullEventsData.filter(
                    (item) => item.type.toLowerCase() === value.toLowerCase()
                  );
                  setEventsData(
                    value === "All" ? fullEventsData : filteredData
                  );
                  setSelectedEventsFilter(value);
                }}
              >
                <div>
                  <Grid container spacing={2}>
                    {eventsData.length > 0 ? (
                      <>
                        {eventsData.map((item, index) => {
                          const isYouTubeValid =
                            item.isYouTubeLink &&
                            item.youtubeUrl?.match(
                              /^https:\/\/(www\.youtube\.com|youtu\.be)\//
                            );
                          const hasFilePath =
                            item.filePath && item.filePath !== "";

                          return (
                            <Grid item xs={12} sm={6} md={6} key={index}>
                              <Card
                                elevation={1}
                                square
                                sx={{
                                  overflow: "hidden",
                                  color: "#ffffff",
                                  borderRadius: "3px",
                                  boxShadow: "none",
                                  position: "relative",
                                  backgroundColor: "#393939",
                                }}
                              >
                                {(isYouTubeValid || hasFilePath) && (
                                  <Avatar
                                    onClick={() =>
                                      handleCheckLeadershipVideo(
                                        item.isYouTubeLink,
                                        item.youtubeUrl,
                                        item.filePath,
                                        item.title
                                      )
                                    }
                                    sx={{
                                      width: 40,
                                      height: 30,
                                      bgcolor: "rgba(0,0,0,0.8)",
                                      color: "white",
                                      position: "absolute",
                                      borderRadius: "25%",
                                      cursor: "pointer",
                                      top: "41%",
                                      left: "50%",
                                      transform: "translate(-50%, -50%)",
                                      transition: "background-color 0.3s ease",
                                      "&:hover": {
                                        bgcolor: "#FF0000",
                                      },
                                    }}
                                  >
                                    ▶
                                  </Avatar>
                                )}

                                <Box
                                  sx={{
                                    padding: "8px 8px 0px 8px",
                                    overflow: "hidden",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    if (!(isYouTubeValid || hasFilePath)) {
                                      window.open(item.youtubeUrl, "_blank");
                                    }
                                  }}
                                >
                                  <img
                                    src={item.thumbNailPath || ""}
                                    alt={item.title}
                                    style={{
                                      width: "100%",
                                      height: "87px",
                                      objectFit: "cover",
                                      backgroundColor: "#393939",
                                      display: "block",
                                    }}
                                  />
                                </Box>

                                {item.type === "video" && (
                                  <Avatar
                                    sx={{
                                      width: 40,
                                      height: 30,
                                      bgcolor: "rgba(0,0,0,0.8)",
                                      color: "white",
                                      position: "absolute",
                                      borderRadius: "25%",
                                      top: "41%",
                                      left: "50%",
                                      transform: "translate(-50%, -50%)",
                                      transition: "background-color 0.3s ease",
                                      "&:hover": {
                                        bgcolor: "#FF0000",
                                      },
                                    }}
                                  >
                                    ▶
                                  </Avatar>
                                )}

                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      padding: "8px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      width: "65%",
                                    }}
                                  >
                                    <Typography
                                      fontWeight="400"
                                      sx={{
                                        maxWidth: "100%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <CustomTooltip
                                        fontSize="12px"
                                        text={item.title}
                                      />
                                    </Typography>
                                  </Box>
                                  {hasEventsAccess && (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <img
                                        src={EditIcon}
                                        alt="Edit"
                                        style={{ cursor: "pointer" }}
                                        width={20}
                                        height={20}
                                        onClick={() =>
                                          handleGetEditEventsData(item)
                                        }
                                      />
                                      <img
                                        src={DeleteIcon}
                                        alt="Delete"
                                        style={{
                                          marginLeft: "8px",
                                          marginRight: "8px",
                                          cursor: "pointer",
                                        }}
                                        width={20}
                                        height={20}
                                        onClick={() =>
                                          handleOpenDeleteModal(item, "events")
                                        }
                                      />
                                    </Box>
                                  )}
                                </Box>
                              </Card>
                            </Grid>
                          );
                        })}
                      </>
                    ) : (
                      <Grid item xs={12}>
                        <Box className="noDataContainer">
                          <Typography>No Data Available</Typography>
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </div>
              </MediaCardSection>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <MainCards
                title="Wallpapers"
                minHeight="340px"
                // addButton={hasWallpapersAccess}
                onButtonClick={handleWallpaperModalOpen}
              >
                <>
                  <Box p={1} pt={0} pb={0}>
                    <List disablePadding>
                      <ListItem
                        component="a"
                        target="_blank"
                        href="https://www.royalenfield.com/in/en/our-world/wallpaper/"
                        style={{
                          borderBottom: "1px solid #808080",
                          display: "flex",
                          alignItems: "center",
                          padding: "12px 5px",
                          cursor: "pointer",
                          textDecoration: "none",
                          color: "inherit",
                        }}
                      >
                        <Box
                          style={{
                            display: "flex",
                            alignItems: "top",
                            justifyContent: "center",
                            marginRight: 12,
                          }}
                        >
                          <img
                            src={RE_Logo}
                            alt="Company Logo"
                            style={{ width: 40, height: 40 }}
                          />
                        </Box>

                        <Box width="50%">Wallpaper for 2025</Box>
                      </ListItem>
                    </List>
                  </Box>

                  <Box p={1} sx={{ display: "none" }}>
                    <Grid container spacing={2}>
                      {wallpaperData.length > 0 ? (
                        wallpaperData.map((item, index) => (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            key={index}
                            style={{ marginBottom: "10px" }}
                          >
                            <Box
                              sx={{
                                width: "85%",
                                height: "85%",
                                mx: "auto",
                                overflow: "hidden",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                src={item.url || item.filePath}
                                alt="img"
                                style={{
                                  width: "100%",
                                  objectFit: "cover",
                                  height: "100%",
                                }}
                              />
                            </Box>

                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                // marginX: "16px",
                                alignItems: "center",
                                mx: "auto",
                                width: "85%",
                                mt: "5px",
                                marginBottom: "10px",
                              }}
                            >
                              <CustomTooltip text={item.title} maxLength={15} />

                              {hasWallpapersAccess && (
                                <Box
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <img
                                    src={EditIcon}
                                    alt="Edit"
                                    style={{ cursor: "pointer" }}
                                    width={20}
                                    height={20}
                                    onClick={() => handleEditWallpaper(item)}
                                  />
                                  <img
                                    src={DeleteIcon}
                                    alt="Delete"
                                    style={{
                                      marginLeft: "5px",
                                      cursor: "pointer",
                                    }}
                                    width={20}
                                    height={20}
                                    onClick={() =>
                                      handleOpenDeleteModal(item, "wallpaper")
                                    }
                                  />
                                </Box>
                              )}
                            </Box>
                          </Grid>
                        ))
                      ) : (
                        <Grid item xs={12}>
                          <Box className="noDataContainer">
                            <Typography>No Data Available</Typography>
                          </Box>
                        </Grid>
                      )}
                    </Grid>
                  </Box>
                </>
              </MainCards>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <MainCards
                title="Useful Links"
                minHeight="340px"
                addButton={hasUsefulLinksAccess}
                onButtonClick={handleUseFullLinksModalOpen}
              >
                <Box p={1} paddingTop={0} paddingBottom={0}>
                  {useFullLinksData.length > 0 ? (
                    <List disablePadding>
                      {useFullLinksData.map((item, index) => (
                        <ListItemButton
                          key={index}
                          component="a"
                          target="blank"
                          href={item.spaceLink}
                          style={{
                            borderBottom: "1px solid #808080",
                            padding: "10px 5px",
                            textDecoration: "none",
                            color: "#ffffff",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Box
                              style={{
                                width: 36,
                                height: 36,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginRight: 10,
                              }}
                            >
                              <img
                                src={item.logoUrl}
                                alt="Img"
                                style={{
                                  width: 32,
                                  height: 32,
                                  objectFit: "cover",
                                }}
                              />
                            </Box>
                            <Box>
                              <Typography
                                className="f-14"
                                sx={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <CustomTooltip text={item.title ?? ""} />
                              </Typography>
                            </Box>
                          </Box>
                          {hasUsefulLinksAccess && (
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <img
                                src={EditIcon}
                                alt="Edit"
                                style={{ cursor: "pointer", marginLeft: "8px" }}
                                width={20}
                                height={20}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleUseFullLinksUpdateData(item);
                                }}
                              />
                              <img
                                src={DeleteIcon}
                                alt="Delete"
                                style={{ marginLeft: "8px", cursor: "pointer" }}
                                width={20}
                                height={20}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleOpenDeleteModal(item, "UseFullLinks");
                                }}
                              />
                            </Box>
                          )}
                        </ListItemButton>
                      ))}
                    </List>
                  ) : (
                    <Grid item xs={12}>
                      <Box className="noDataContainer">
                        <Typography>No Data Available</Typography>
                      </Box>
                    </Grid>
                  )}
                </Box>
              </MainCards>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <MainCards
                title="RE Social"
                minHeight="340px"
                addButton={false}
                onButtonClick={handleReSocialOpen}
              >
                {reSocialList.length > 0 ? (
                  <Box
                    display="grid"
                    gridTemplateColumns={{
                      xs: "repeat(2, 1fr)",
                      sm: "repeat(3, 1fr)",
                    }}
                    gap={3}
                    justifyContent="center"
                    alignItems="center"
                    p={2}
                  >
                    {reSocialList
                      .sort((a, b) => {
                        const aIndex = customOrder.indexOf(a.title ?? "");
                        const bIndex = customOrder.indexOf(b.title ?? "");
                        return aIndex - bIndex;
                      })
                      .map((item, index) => (
                        <Box
                          key={index}
                          display="flex"
                          flexDirection="row"
                          component="a"
                          target="_blank"
                          href={item.socialMediaLink}
                          alignItems="center"
                          justifyContent="center"
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            p: {
                              sm: "24px 0px",
                              md: "24px 0px",
                              lg: "32px 10px",
                            },
                          }}
                          position="relative"
                        >
                          <Box>
                            <Box color="#666" textAlign={"center"}>
                              {getSocialIcon(item.title ?? "")}
                            </Box>
                            <Typography
                              variant="body2"
                              sx={{ textAlign: "center" }}
                            >
                              {item.title}
                            </Typography>
                          </Box>
                          {hasRESocialAccess && (
                            <Box>
                              <img
                                src={EditIcon}
                                alt="Edit"
                                style={{
                                  width: 20,
                                  height: 20,
                                  cursor: "pointer",
                                }}
                                onClick={() => handleRESocialUpdateData(item)}
                              />
                            </Box>
                          )}
                        </Box>
                      ))}
                  </Box>
                ) : (
                  <Grid item xs={12}>
                    <Box className="noDataContainer">
                      <Typography>No Data Available</Typography>
                    </Box>
                  </Grid>
                )}
              </MainCards>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: "center",
                  gap: 1,
                  p: "10px 16px",
                  bgcolor: "#212121",
                  borderRadius: 0,
                  color: "white",
                  overflowX: "auto",
                }}
              >
                <Box
                  sx={{
                    width: { xs: "100%", sm: "20%", md: "15%", lg: "11%" },
                    display: "flex",
                    justifyContent: { xs: "center", sm: "flex-start" },
                  }}
                >
                  <Typography className="f-16" fontWeight={700}>
                    Motorcycles
                  </Typography>
                  {hasMotorcyclesAccess && (
                    <Button
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "0px",
                        width: "fit-content",
                        minWidth: "fit-content",
                        ml: 1.5,
                        // mr: 2,
                      }}
                    >
                      <img
                        src={AddIcon}
                        alt="Add"
                        width={20}
                        height={20}
                        onClick={handleOurMotorcycleOpen}
                      />
                    </Button>
                  )}
                </Box>

                <Box
                  sx={{
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    maxWidth: { xs: "100%", sm: "89%" },
                    display: "flex",
                  }}
                >
                  {motorcycleData.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        flexShrink: 0,
                      }}
                    >
                      <Typography
                        component="a"
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          color: "white",
                          fontSize: "14px",
                          textDecoration: "none",
                        }}
                      >
                        {item.title}
                      </Typography>
                      {hasMotorcyclesAccess && (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={EditIcon}
                            alt="Edit"
                            style={{ cursor: "pointer" }}
                            width={20}
                            height={20}
                            onClick={() => handleMotorcycleUpdateData(item)}
                          />
                          <img
                            src={DeleteIcon}
                            alt="Delete"
                            style={{
                              marginLeft: "5px",
                              cursor: "pointer",
                            }}
                            width={20}
                            height={20}
                            onClick={() =>
                              handleOpenDeleteModal(item, "motorcycleData")
                            }
                          />
                        </Box>
                      )}
                      {index !== motorcycleData.length - 1 && (
                        <Typography sx={{ color: "#ffffff", mr: 1, my: 1 }}>
                          |
                        </Typography>
                      )}
                    </Box>
                  ))}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* ------------Admin Modal code start------------------- */}
        {/* Banner Image Modal code  */}
        {bannerImageMdl && (
          <BannerImageModal
            onClose={handleBannerImageModalClose}
            open={bannerImageMdl}
            onSave={handleBannerImageSaveData}
            bannerImageList={bannerImageList}
          />
        )}

        {/* Space Modal code  */}
        {spaceMdl && (
          <SpacesModal
            onClose={handleCloseSpaceModal}
            open={spaceMdl}
            onSave={handleSpaceSaveData}
            spaceUpdateData={spaceUpdateData}
          />
        )}

        {/* Leadership Corner Modal code - */}
        {leadershipCornerMdl && (
          <LeadershipCornerModal
            onClose={handleCloseLeadershipCornerModal}
            open={leadershipCornerMdl}
            onSave={handleLeadershipCornerSaveData}
            leadershipCornerUpdateData={leadershipCornerUpdateData}
            leadershipTypesList={
              leadershipTypesList ? leadershipTypesList?.slice(1) : []
            }
          />
        )}

        {/* Holiday Modal code  */}
        {stateList && (
          <HolidayModal
            onClose={handleHolidayModalClose}
            open={holidayMdl}
            onSave={handleHolidaySaveData}
            states={stateList}
            holidayUpdateData={holidayUpdateData}
          />
        )}

        <AllTheHelpYouNeedModal
          onClose={handleREImagineModalClose}
          open={isREImagineModalOpen && rEImageActiveTab === 1}
          onSave={handleREImagineSaveData}
        />

        <IdeaCapturingModal
          onClose={handleREImagineModalClose}
          open={isREImagineModalOpen && rEImageActiveTab === 0}
          onSave={handleREImagineSaveData}
          reImagineUpdateData={reImagineUpdateData}
        />

        {/* Rewards And Recognition Modal Code */}
        {rewardAndRecognitionModalOpen && (
          <RewardsAndRecognitionModal
            onClose={handleRewardAndRecognitionModalClose}
            open={rewardAndRecognitionModalOpen}
            onSave={handleRewardAndRecognitionSaveData}
            rewardsRecognitionData={rewardsRecognitionData}
          />
        )}

        {/* Learning & Development Modal code  */}
        {learningDevelopmentMdl && (
          <LearningDevelopmentModal
            onClose={handleLearningDevelopmentModalClose}
            open={learningDevelopmentMdl}
            onSave={handleLearningDevelopmentSaveData}
            learningDevelopmentUpdateData={learningDevelopmentUpdateData}
          />
        )}

        {/* Internal Job posting Modal code  */}
        {internalJobOpen && (
          <InternalJobPosting
            onClose={handleClose}
            open={internalJobOpen}
            onSave={handleInternalJobSaveData}
            jobUpdateData={jobUpdateData}
          />
        )}

        {/* RE Social Modal code  */}
        {reSocialOpen && (
          <RESocial
            onClose={handleClose}
            open={reSocialOpen}
            onSave={handleReSocialSaveData}
            updatepReSocialData={updatepReSocial}
          />
        )}

        {/* I Refer Modal code  */}
        {iReferOpen && (
          <IRefer
            onClose={handleClose}
            open={iReferOpen}
            onSave={handleIReferSaveData}
            updatepEmployeeIRefer={updatepEmployeeIRefer}
          />
        )}

        {/* OpenRoad Modal code  */}
        {openRoadOpen && (
          <OpenRoad
            onClose={handleClose}
            open={openRoadOpen}
            onSave={handleOpenRoadSaveData}
            openRoadUpdateData={openRoadUpdateData}
            openRoadTypesList={
              openRoadTypesList ? openRoadTypesList?.slice(1) : []
            }
          />
        )}

        {/* Social Mission Modal code */}
        {socialMissionOpen && (
          <SocialMission
            onClose={handleSocialMissionClose}
            open={socialMissionOpen}
            onSave={handleSocialMissionSaveData}
            socialMissionUpdateData={socialMissionUpdateData}
            socialMissionTypesList={
              socialMissionTypesList ? socialMissionTypesList?.slice(1) : []
            }
          />
        )}

        {/* Wallpaper Modal code */}
        {isWallpaperModalOpen && (
          <WallpaperModal
            onClose={handleWallpaperModalClose}
            open={isWallpaperModalOpen}
            onSave={handleSaveWallpaperModal}
            wallpaperUpdateData={wallpaperUpdateData}
          />
        )}

        {/* Events Modal Modal code */}
        {isVideoVaultModalOpen && (
          <EventsModal
            onClose={handleVideoVaultModalClose}
            open={isVideoVaultModalOpen}
            onSave={handleSaveVideoVaultModal}
            eventsUpdateData={eventsUpdateData}
            eventsTypesList={eventsTypesList ? eventsTypesList.slice(1) : []}
          />
        )}

        {/* Performance Management Modal Code */}
        {isPerformanceModalOpen && (
          <PerformanceManagement
            onClose={handlePerformanceModalClose}
            open={isPerformanceModalOpen}
            onSave={handleSavePerformanceModal}
            updatepPerformanceData={updatepPerformanceManagement}
          />
        )}

        {/* Our Motorcycle Modal code  */}
        {isOurMotorcycleOpen && (
          <OurMotorcycle
            onClose={handleOurMotorcycleClose}
            open={isOurMotorcycleOpen}
            onSave={handleSaveOurMotorcycle}
            updateMotorcycleData={updateMotorcycleData}
          />
        )}

        {/* NPI Modal code  */}
        {isNPIModalOpen && (
          <NPIModal
            onClose={handleNPIModalClose}
            open={isNPIModalOpen}
            onSave={handleSaveNPIModal}
            NPIUpdateData={NPIUpdateData}
          />
        )}

        {/* Use Ful Links Modal code  */}
        {isUseFullLinksModalOpen && (
          <UseFullLinksModals
            onClose={handleUseFullLinksModalClose}
            open={isUseFullLinksModalOpen}
            onSave={handleSaveUseFullLinksModal}
            useFullLinksUpdateData={useFullLinksUpdateData}
          />
        )}

        {/* ------------Admin Modal code end------------------- */}
        <DeleteModal
          open={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
          onDelete={handleDeleteData}
        />

        {/* ------------ award accepted Pop Up ------------------- */}

        <AwardAccepted
          open={isAwardAcceptedModalOpen}
          onClose={() => {
            setIsAwardAcceptedModalOpen(false);
            navigate("/dashboard");
          }}
          onSave={() => {
            setIsAwardAcceptedModalOpen(false);
            navigate("/dashboard");
          }}
          rewardMessage={rewardMessage}
          isLoading={isLoading}
        />
        {/* ------------ Reward acceptance Form Pop Up ------------------- */}
        {rewardAcceptanceFormData && (
          <RewardAcceptanceForm
            open={isRewardAcceptanceFormOpen}
            onClose={() => {
              setIsRewardAcceptanceFormOpen(false);
              navigate("/dashboard");
              fetchRewardAndRecognizationData();
            }}
            onSave={() => {
              setIsRewardAcceptanceFormOpen(false);
              navigate("/dashboard");
              fetchRewardAndRecognizationData();
            }}
            rewardAcceptanceFormData={rewardAcceptanceFormData}
            isLoading={isLoading}
          />
        )}
        {/* ------------ReImagine Access Modal ------------------- */}
        <ReImagineAccessModal
          open={isREImagineAccessModalOpen}
          onClose={() => {
            setIsREImagineAccessModalOpen(false);
            navigate("/dashboard");
          }}
          reImagineUpdateData={reImagineAccessData}
        />
        {/* ------------Video Modal Pop Up ------------------- */}
        {videoModalOpen && (
          <VideoModal
            open={videoModalOpen}
            handleClose={() => setVideoModalOpen(false)}
            videoSrc={videoURL}
            title={fileTitle}
            isYoutube={isYouTubeVideo}
          />
        )}

        {/* Dashboard Search Modal code  */}
        {dashboardSearchModal && (
          <DashboardSearchModal
            onClose={handleDashboardSearchClose}
            open={dashboardSearchModal}
            searchResult={dashboardSearchData}
          />
        )}
      </div>
    </>
  );
};

export default Dashboard;
